// // // // // // import { useState, useEffect } from "react";
// // // // // // import Typography from "@mui/material/Typography";
// // // // // // import CircularProgress from '@mui/material/CircularProgress';
// // // // // // import axiosClient from "../axiosClient";
// // // // // // import * as XLSX from "xlsx";
// // // // // // import {
// // // // // //   Box,
// // // // // //   Button,
// // // // // //   CardContent,
// // // // // //   Table,
// // // // // //   TableCell,
// // // // // //   TableContainer,
// // // // // //   TableHead,
// // // // // //   TableRow,
// // // // // //   TextField,
// // // // // //   MenuItem,
// // // // // //   Select,
// // // // // //   InputLabel,
// // // // // //   FormControl,
// // // // // //   Grid,
// // // // // // } from "@mui/material";
// // // // // // import { Card, Paper, TableBody } from "@mui/material";
// // // // // // import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// // // // // // import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// // // // // // import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// // // // // // import dayjs from 'dayjs';
// // // // // // import isoWeek from 'dayjs/plugin/isoWeek';

// // // // // // dayjs.extend(isoWeek);

// // // // // // function SendEmailSMS() {
// // // // // //   const [message, setMessage] = useState("Loading Excel data...");
// // // // // //   const [loading, setLoading] = useState(true);
// // // // // //   const [error, setError] = useState(null);
// // // // // //   const [excelData, setExcelData] = useState([]);
// // // // // //   const [periodType, setPeriodType] = useState('month');
// // // // // //   const [selectedDate, setSelectedDate] = useState(dayjs());
// // // // // //   const [recipientEmail, setRecipientEmail] = useState('');
// // // // // //   const [reportMessage, setReportMessage] = useState('');
// // // // // //   const [emailError, setEmailError] = useState('');

// // // // // //   useEffect(() => {
// // // // // //     displayData();
// // // // // //   }, []);

// // // // // //   const validateEmail = (email) => {
// // // // // //     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// // // // // //     return emailRegex.test(email);
// // // // // //   };

// // // // // //   const handleEmailChange = (e) => {
// // // // // //     const email = e.target.value;
// // // // // //     setRecipientEmail(email);
// // // // // //     if (email && !validateEmail(email)) {
// // // // // //       setEmailError('Please enter a valid email address');
// // // // // //     } else {
// // // // // //       setEmailError('');
// // // // // //     }
// // // // // //   };

// // // // // //   const clearForm = () => {
// // // // // //     setPeriodType('month');
// // // // // //     setSelectedDate(dayjs());
// // // // // //     setRecipientEmail('');
// // // // // //     setEmailError('');
// // // // // //     setReportMessage('');
// // // // // //   };

// // // // // //   const downloadExcel = () => {
// // // // // //     setLoading(true);
// // // // // //     setMessage("Downloading file...");

// // // // // //     axiosClient
// // // // // //       .get("api/excel_document_of_email_sms/", { responseType: "blob" })
// // // // // //       .then((response) => {
// // // // // //         const file = new Blob([response.data]);

// // // // // //         // Trigger file download
// // // // // //         const url = window.URL.createObjectURL(file);
// // // // // //         const link = document.createElement("a");
// // // // // //         link.href = url;
// // // // // //         link.setAttribute("download", "email_sms.xlsx");
// // // // // //         document.body.appendChild(link);
// // // // // //         link.click();
// // // // // //         document.body.removeChild(link); // Clean up after download

// // // // // //         setLoading(false);
// // // // // //         setMessage("File downloaded successfully!");
// // // // // //       })
// // // // // //       .catch((err) => {
// // // // // //         setError("Failed to download file.");
// // // // // //         setLoading(false);
// // // // // //       });
// // // // // //   };

// // // // // //   const displayData = () => {
// // // // // //     setLoading(true);
// // // // // //     setMessage("Loading data...");

// // // // // //     axiosClient
// // // // // //       .get("api/excel_document_of_email_sms/", { responseType: "blob" })
// // // // // //       .then((response) => {
// // // // // //         const file = new Blob([response.data]);
// // // // // //         const reader = new FileReader();

// // // // // //         // Read the file for displaying its contents
// // // // // //         reader.onload = (e) => {
// // // // // //           const data = new Uint8Array(e.target.result);
// // // // // //           const workbook = XLSX.read(data, { type: "array" });

// // // // // //           // Parse data from the first sheet
// // // // // //           const worksheet = workbook.Sheets[workbook.SheetNames[0]];
// // // // // //           const jsonData = XLSX.utils.sheet_to_json(worksheet);

// // // // // //           setExcelData(jsonData);
// // // // // //           setLoading(false);
// // // // // //           setMessage("Data loaded successfully!");
// // // // // //         };

// // // // // //         reader.onerror = () => {
// // // // // //           setError("Error reading the Excel file.");
// // // // // //           setLoading(false);
// // // // // //         };

// // // // // //         reader.readAsArrayBuffer(file); // Trigger reading of the file
// // // // // //       })
// // // // // //       .catch((err) => {
// // // // // //         setError("Failed to load data.");
// // // // // //         setLoading(false);
// // // // // //       });
// // // // // //   };

// // // // // //   const handleSendReport = () => {
// // // // // //     if (!validateEmail(recipientEmail)) {
// // // // // //       setEmailError('Please enter a valid email address');
// // // // // //       return;
// // // // // //     }

// // // // // //     setLoading(true);
// // // // // //     setReportMessage('');

// // // // // //     let periodValue;
// // // // // //     if (periodType === 'month') {
// // // // // //       periodValue = selectedDate.format('YYYY-MM');
// // // // // //     } else {
// // // // // //       periodValue = `${selectedDate.format('YYYY')}-W${selectedDate.isoWeek()}`;
// // // // // //     }

// // // // // //     axiosClient
// // // // // //       .post("/api/sms-report/", {
// // // // // //         period_type: periodType,
// // // // // //         period_value: periodValue,
// // // // // //         email: recipientEmail
// // // // // //       })
// // // // // //       .then((response) => {
// // // // // //         setReportMessage(response.data.message);
// // // // // //         setLoading(false);
// // // // // //       })
// // // // // //       .catch((err) => {
// // // // // //         setReportMessage(err.response?.data?.error || 'Failed to send report');
// // // // // //         setLoading(false);
// // // // // //       });
// // // // // //   };

// // // // // //   return (
// // // // // //     <LocalizationProvider dateAdapter={AdapterDayjs}>
// // // // // //       <Box sx={{ p: 3 }}>
// // // // // //         <Typography variant="h6" align="center" gutterBottom>
// // // // // //           Send SMS Report
// // // // // //         </Typography>

// // // // // //         <Grid container spacing={2} sx={{ mb: 3 }}>
// // // // // //           {/* Form Controls */}
// // // // // //           <Grid item xs={12} sm={4}>
// // // // // //             <FormControl fullWidth>
// // // // // //               <InputLabel>Period Type</InputLabel>
// // // // // //               <Select
// // // // // //                 value={periodType}
// // // // // //                 onChange={(e) => setPeriodType(e.target.value)}
// // // // // //                 label="Period Type"
// // // // // //               >
// // // // // //                 <MenuItem value="month">Month</MenuItem>
// // // // // //                 <MenuItem value="week">Week</MenuItem>
// // // // // //               </Select>
// // // // // //             </FormControl>
// // // // // //           </Grid>
// // // // // //           <Grid item xs={12} sm={4}>
// // // // // //             <DatePicker
// // // // // //               label={periodType === 'month' ? 'Select Month' : 'Select Week'}
// // // // // //               views={periodType === 'month' ? ['year', 'month'] : ['year', 'month', 'day']}
// // // // // //               value={selectedDate}
// // // // // //               onChange={(newValue) => setSelectedDate(newValue)}
// // // // // //               slotProps={{ textField: { fullWidth: true } }}
// // // // // //             />
// // // // // //           </Grid>
// // // // // //           <Grid item xs={12} sm={4}>
// // // // // //             <TextField
// // // // // //               fullWidth
// // // // // //               label="Recipient Email"
// // // // // //               value={recipientEmail}
// // // // // //               onChange={handleEmailChange}
// // // // // //               type="email"
// // // // // //               error={!!emailError}
// // // // // //               helperText={emailError}
// // // // // //             />
// // // // // //           </Grid>

// // // // // //           {/* Action Buttons */}
// // // // // //           <Grid item xs={12}>
// // // // // //             <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', justifyContent: 'center' }}>
// // // // // //               <Button
// // // // // //                 variant="contained"
// // // // // //                 color="secondary"
// // // // // //                 onClick={handleSendReport}
// // // // // //                 disabled={loading || !recipientEmail || !!emailError}
// // // // // //               >
// // // // // //                 Send SMS Report
// // // // // //               </Button>
// // // // // //               <Button
// // // // // //                 variant="outlined"
// // // // // //                 color="primary"
// // // // // //                 onClick={clearForm}
// // // // // //                 disabled={loading}
// // // // // //               >
// // // // // //                 Clear
// // // // // //               </Button>
// // // // // //             </Box>
// // // // // //           </Grid>

// // // // // //           {/* Status Messages and Loading Indicator */}
// // // // // //           <Grid item xs={12}>
// // // // // //             <Box sx={{ textAlign: 'center', mt: 2 }}>
// // // // // //               {loading && <CircularProgress sx={{ mb: 2 }} />}
// // // // // //               {reportMessage && (
// // // // // //                 <Typography
// // // // // //                   variant="body1"
// // // // // //                   color={reportMessage.includes('successfully') ? 'success.main' : 'error.main'}
// // // // // //                 >
// // // // // //                   {reportMessage}
// // // // // //                 </Typography>
// // // // // //               )}
// // // // // //             </Box>
// // // // // //           </Grid>
// // // // // //         </Grid>

// // // // // //         {/* Excel Data and Download Button */}
// // // // // //         <Card elevation={16}>
// // // // // //           <CardContent>
// // // // // //             <Box sx={{ mb: 2, textAlign: 'center' }}>
// // // // // //               {loading ? (
// // // // // //                 <Typography variant="h6" color="text.primary">
// // // // // //                   Loading data...
// // // // // //                 </Typography>
// // // // // //               ) : error ? (
// // // // // //                 <Typography variant="h6" color="error.main">
// // // // // //                   {error}
// // // // // //                 </Typography>
// // // // // //               ) : (
// // // // // //                 <Typography variant="h6" color="text.primary">
// // // // // //                   {message}
// // // // // //                 </Typography>
// // // // // //               )}
// // // // // //             </Box>
// // // // // //             <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
// // // // // //               <Button
// // // // // //                 variant="contained"
// // // // // //                 color="primary"
// // // // // //                 onClick={downloadExcel}
// // // // // //                 disabled={loading}
// // // // // //               >
// // // // // //                 Download Excel File
// // // // // //               </Button>
// // // // // //             </Box>
// // // // // //             {!loading && !error && excelData.length > 0 && (
// // // // // //               <TableContainer component={Paper} style={{ maxHeight: 800 }}>
// // // // // //                 <Typography variant="h6" gutterBottom>
// // // // // //                   Excel Data:
// // // // // //                 </Typography>
// // // // // //                 <Table>
// // // // // //                   <TableHead>
// // // // // //                     <TableRow>
// // // // // //                       {excelData.length > 0 &&
// // // // // //                         Object.keys(excelData[0]).map((key) => (
// // // // // //                           <TableCell key={key}>{key}</TableCell>
// // // // // //                         ))}
// // // // // //                     </TableRow>
// // // // // //                   </TableHead>
// // // // // //                   <TableBody>
// // // // // //                     {excelData.map((row, index) => (
// // // // // //                       <TableRow key={index}>
// // // // // //                         {Object.values(row).map((val, i) => (
// // // // // //                           <TableCell key={i}>{val}</TableCell>
// // // // // //                         ))}
// // // // // //                       </TableRow>
// // // // // //                     ))}
// // // // // //                   </TableBody>
// // // // // //                 </Table>
// // // // // //               </TableContainer>
// // // // // //             )}
// // // // // //           </CardContent>
// // // // // //         </Card>
// // // // // //       </Box>
// // // // // //     </LocalizationProvider>
// // // // // //   );
// // // // // // }

// // // // // // export default SendEmailSMS;



// // // // // import { useState, useEffect } from "react";
// // // // // import Typography from "@mui/material/Typography";
// // // // // import CircularProgress from "@mui/material/CircularProgress";
// // // // // import axiosClient from "../axiosClient";
// // // // // import * as XLSX from "xlsx";
// // // // // import {
// // // // //   Box,
// // // // //   Button,
// // // // //   CardContent,
// // // // //   Table,
// // // // //   TableCell,
// // // // //   TableContainer,
// // // // //   TableHead,
// // // // //   TableRow,
// // // // //   TextField,
// // // // //   MenuItem,
// // // // //   Select,
// // // // //   InputLabel,
// // // // //   FormControl,
// // // // //   Grid,
// // // // // } from "@mui/material";
// // // // // import { Card, Paper, TableBody } from "@mui/material";
// // // // // import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// // // // // import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// // // // // import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// // // // // import dayjs from "dayjs";
// // // // // import isoWeek from "dayjs/plugin/isoWeek";
// // // // // import { useTranslation } from "react-i18next";

// // // // // dayjs.extend(isoWeek);

// // // // // function SendEmailSMS() {
// // // // //   const { t } = useTranslation();

// // // // //   // αποθηκεύουμε KEYS και όχι έτοιμα κείμενα
// // // // //   const [messageKey, setMessageKey] = useState("excel.loadingExcelData");
// // // // //   const [loading, setLoading] = useState(true);
// // // // //   const [errorKey, setErrorKey] = useState(null);
// // // // //   const [excelData, setExcelData] = useState([]);
// // // // //   const [periodType, setPeriodType] = useState("month");
// // // // //   const [selectedDate, setSelectedDate] = useState(dayjs());
// // // // //   const [recipientEmail, setRecipientEmail] = useState("");
// // // // //   const [reportMessage, setReportMessage] = useState("");
// // // // //   const [emailErrorKey, setEmailErrorKey] = useState("");

// // // // //   useEffect(() => {
// // // // //     displayData();
// // // // //   }, []);

// // // // //   const validateEmail = (email) => {
// // // // //     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// // // // //     return emailRegex.test(email);
// // // // //   };

// // // // //   const handleEmailChange = (e) => {
// // // // //     const email = e.target.value;
// // // // //     setRecipientEmail(email);
// // // // //     if (email && !validateEmail(email)) {
// // // // //       setEmailErrorKey("validation.validEmail");
// // // // //     } else {
// // // // //       setEmailErrorKey("");
// // // // //     }
// // // // //   };

// // // // //   const clearForm = () => {
// // // // //     setPeriodType("month");
// // // // //     setSelectedDate(dayjs());
// // // // //     setRecipientEmail("");
// // // // //     setEmailErrorKey("");
// // // // //     setReportMessage("");
// // // // //   };

// // // // //   const downloadExcel = () => {
// // // // //     setLoading(true);
// // // // //     setMessageKey("excel.downloadingFile");
// // // // //     setErrorKey(null);

// // // // //     axiosClient
// // // // //       .get("api/excel_document_of_email_sms/", { responseType: "blob" })
// // // // //       .then((response) => {
// // // // //         const file = new Blob([response.data]);

// // // // //         // Trigger file download
// // // // //         const url = window.URL.createObjectURL(file);
// // // // //         const link = document.createElement("a");
// // // // //         link.href = url;
// // // // //         link.setAttribute("download", "email_sms.xlsx");
// // // // //         document.body.appendChild(link);
// // // // //         link.click();
// // // // //         document.body.removeChild(link);

// // // // //         setLoading(false);
// // // // //         setMessageKey("excel.fileDownloadedSuccessfully");
// // // // //       })
// // // // //       .catch(() => {
// // // // //         setErrorKey("excel.failedToDownloadFile");
// // // // //         setLoading(false);
// // // // //       });
// // // // //   };

// // // // //   const displayData = () => {
// // // // //     setLoading(true);
// // // // //     setMessageKey("excel.loadingData");
// // // // //     setErrorKey(null);

// // // // //     axiosClient
// // // // //       .get("api/excel_document_of_email_sms/", { responseType: "blob" })
// // // // //       .then((response) => {
// // // // //         const file = new Blob([response.data]);
// // // // //         const reader = new FileReader();

// // // // //         reader.onload = (e) => {
// // // // //           const data = new Uint8Array(e.target.result);
// // // // //           const workbook = XLSX.read(data, { type: "array" });

// // // // //           const worksheet = workbook.Sheets[workbook.SheetNames[0]];
// // // // //           const jsonData = XLSX.utils.sheet_to_json(worksheet);

// // // // //           setExcelData(jsonData);
// // // // //           setLoading(false);
// // // // //           setMessageKey("excel.dataLoadedSuccessfully");
// // // // //         };

// // // // //         reader.onerror = () => {
// // // // //           setErrorKey("excel.errorReadingFile");
// // // // //           setLoading(false);
// // // // //         };

// // // // //         reader.readAsArrayBuffer(file);
// // // // //       })
// // // // //       .catch(() => {
// // // // //         setErrorKey("excel.failedToLoadData");
// // // // //         setLoading(false);
// // // // //       });
// // // // //   };

// // // // //   const handleSendReport = () => {
// // // // //     if (!validateEmail(recipientEmail)) {
// // // // //       setEmailErrorKey("validation.validEmail");
// // // // //       return;
// // // // //     }

// // // // //     setLoading(true);
// // // // //     setReportMessage("");

// // // // //     let periodValue;
// // // // //     if (periodType === "month") {
// // // // //       periodValue = selectedDate.format("YYYY-MM");
// // // // //     } else {
// // // // //       periodValue = `${selectedDate.format("YYYY")}-W${selectedDate.isoWeek()}`;
// // // // //     }

// // // // //     axiosClient
// // // // //       .post("/api/sms-report/", {
// // // // //         period_type: periodType,
// // // // //         period_value: periodValue,
// // // // //         email: recipientEmail,
// // // // //       })
// // // // //       .then((response) => {
// // // // //         setReportMessage(response.data.message);
// // // // //         setLoading(false);
// // // // //       })
// // // // //       .catch((err) => {
// // // // //         setReportMessage(
// // // // //           err.response?.data?.error || t("smsReport.failedToSendReport")
// // // // //         );
// // // // //         setLoading(false);
// // // // //       });
// // // // //   };

// // // // //   return (
// // // // //     <LocalizationProvider dateAdapter={AdapterDayjs}>
// // // // //       <Box sx={{ p: 3 }}>
// // // // //         {/* ΤΙΤΛΟΣ ΣΕΛΙΔΑΣ */}
// // // // //         <Typography variant="h6" align="center" gutterBottom>
// // // // //           {t("smsReport.title")}
// // // // //         </Typography>

// // // // //         <Grid container spacing={2} sx={{ mb: 3 }}>
// // // // //           {/* Period Type */}
// // // // //           <Grid item xs={12} sm={4}>
// // // // //             <FormControl fullWidth>
// // // // //               <InputLabel>{t("smsReport.periodType")}</InputLabel>
// // // // //               <Select
// // // // //                 value={periodType}
// // // // //                 onChange={(e) => setPeriodType(e.target.value)}
// // // // //                 label={t("smsReport.periodType")}
// // // // //               >
// // // // //                 <MenuItem value="month">{t("smsReport.periodMonth")}</MenuItem>
// // // // //                 <MenuItem value="week">{t("smsReport.periodWeek")}</MenuItem>
// // // // //               </Select>
// // // // //             </FormControl>
// // // // //           </Grid>

// // // // //           {/* Date picker */}
// // // // //           <Grid item xs={12} sm={4}>
// // // // //             <DatePicker
// // // // //               label={
// // // // //                 periodType === "month"
// // // // //                   ? t("smsReport.selectMonth")
// // // // //                   : t("smsReport.selectWeek")
// // // // //               }
// // // // //               views={
// // // // //                 periodType === "month"
// // // // //                   ? ["year", "month"]
// // // // //                   : ["year", "month", "day"]
// // // // //               }
// // // // //               value={selectedDate}
// // // // //               onChange={(newValue) => setSelectedDate(newValue)}
// // // // //               slotProps={{ textField: { fullWidth: true } }}
// // // // //             />
// // // // //           </Grid>

// // // // //           {/* Recipient email */}
// // // // //           <Grid item xs={12} sm={4}>
// // // // //             <TextField
// // // // //               fullWidth
// // // // //               label={t("smsReport.recipientEmail")}
// // // // //               value={recipientEmail}
// // // // //               onChange={handleEmailChange}
// // // // //               type="email"
// // // // //               error={!!emailErrorKey}
// // // // //               helperText={emailErrorKey ? t(emailErrorKey) : ""}
// // // // //             />
// // // // //           </Grid>

// // // // //           {/* Buttons */}
// // // // //           <Grid item xs={12}>
// // // // //             <Box
// // // // //               sx={{
// // // // //                 display: "flex",
// // // // //                 gap: 2,
// // // // //                 alignItems: "center",
// // // // //                 justifyContent: "center",
// // // // //               }}
// // // // //             >
// // // // //               <Button
// // // // //                 variant="contained"
// // // // //                 color="secondary"
// // // // //                 onClick={handleSendReport}
// // // // //                 disabled={loading || !recipientEmail || !!emailErrorKey}
// // // // //               >
// // // // //                 {t("smsReport.sendButton")}
// // // // //               </Button>
// // // // //               <Button
// // // // //                 variant="outlined"
// // // // //                 color="primary"
// // // // //                 onClick={clearForm}
// // // // //                 disabled={loading}
// // // // //               >
// // // // //                 {t("common.clear")}
// // // // //               </Button>
// // // // //             </Box>
// // // // //           </Grid>

// // // // //           {/* Status Messages */}
// // // // //           <Grid item xs={12}>
// // // // //             <Box sx={{ textAlign: "center", mt: 2 }}>
// // // // //               {loading && <CircularProgress sx={{ mb: 2 }} />}
// // // // //               {reportMessage && (
// // // // //                 <Typography
// // // // //                   variant="body1"
// // // // //                   color={
// // // // //                     reportMessage.includes("success")
// // // // //                       ? "success.main"
// // // // //                       : "error.main"
// // // // //                   }
// // // // //                 >
// // // // //                   {reportMessage}
// // // // //                 </Typography>
// // // // //               )}
// // // // //             </Box>
// // // // //           </Grid>
// // // // //         </Grid>

// // // // //         {/* Excel block */}
// // // // //         <Card elevation={16}>
// // // // //           <CardContent>
// // // // //             <Box sx={{ mb: 2, textAlign: "center" }}>
// // // // //               {loading ? (
// // // // //                 <Typography variant="h6" color="text.primary">
// // // // //                   {t("excel.loadingData")}
// // // // //                 </Typography>
// // // // //               ) : errorKey ? (
// // // // //                 <Typography variant="h6" color="error.main">
// // // // //                   {t(errorKey)}
// // // // //                 </Typography>
// // // // //               ) : (
// // // // //                 <Typography variant="h6" color="text.primary">
// // // // //                   {t(messageKey)}
// // // // //                 </Typography>
// // // // //               )}
// // // // //             </Box>

// // // // //             <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
// // // // //               <Button
// // // // //                 variant="contained"
// // // // //                 color="primary"
// // // // //                 onClick={downloadExcel}
// // // // //                 disabled={loading}
// // // // //               >
// // // // //                 {t("excel.downloadButton")}
// // // // //               </Button>
// // // // //             </Box>

// // // // //             {!loading && !errorKey && excelData.length > 0 && (
// // // // //               <TableContainer component={Paper} style={{ maxHeight: 800 }}>
// // // // //                 <Typography variant="h6" gutterBottom>
// // // // //                   {t("excel.excelDataHeader")}
// // // // //                 </Typography>
// // // // //                 <Table>
// // // // //                   <TableHead>
// // // // //                     <TableRow>
// // // // //                       {excelData.length > 0 &&
// // // // //                         Object.keys(excelData[0]).map((key) => (
// // // // //                           <TableCell key={key}>{key}</TableCell>
// // // // //                         ))}
// // // // //                     </TableRow>
// // // // //                   </TableHead>
// // // // //                   <TableBody>
// // // // //                     {excelData.map((row, index) => (
// // // // //                       <TableRow key={index}>
// // // // //                         {Object.values(row).map((val, i) => (
// // // // //                           <TableCell key={i}>{val}</TableCell>
// // // // //                         ))}
// // // // //                       </TableRow>
// // // // //                     ))}
// // // // //                   </TableBody>
// // // // //                 </Table>
// // // // //               </TableContainer>
// // // // //             )}
// // // // //           </CardContent>
// // // // //         </Card>
// // // // //       </Box>
// // // // //     </LocalizationProvider>
// // // // //   );
// // // // // }

// // // // // export default SendEmailSMS;




// // // // // import { useState, useEffect } from "react";
// // // // // import Typography from "@mui/material/Typography";
// // // // // import CircularProgress from "@mui/material/CircularProgress";
// // // // // import axiosClient from "../axiosClient";
// // // // // import * as XLSX from "xlsx";
// // // // // import {
// // // // //   Box,
// // // // //   Button,
// // // // //   CardContent,
// // // // //   Table,
// // // // //   TableCell,
// // // // //   TableContainer,
// // // // //   TableHead,
// // // // //   TableRow,
// // // // //   TextField,
// // // // //   MenuItem,
// // // // //   Select,
// // // // //   InputLabel,
// // // // //   FormControl,
// // // // //   Grid,
// // // // //   Card, 
// // // // //   Paper, 
// // // // //   TableBody,
// // // // // } from "@mui/material";
// // // // // import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// // // // // import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// // // // // import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// // // // // import dayjs from "dayjs";
// // // // // import isoWeek from "dayjs/plugin/isoWeek";
// // // // // import { useTranslation } from "react-i18next";

// // // // // dayjs.extend(isoWeek);

// // // // // function SendEmailSMS() {
// // // // //   const { t } = useTranslation();

// // // // //   const [messageKey, setMessageKey] = useState("");
// // // // //   const [loading, setLoading] = useState(false);
// // // // //   const [errorKey, setErrorKey] = useState(null);
// // // // //   const [excelData, setExcelData] = useState([]);
// // // // //   const [periodType, setPeriodType] = useState("month");
// // // // //   const [selectedDate, setSelectedDate] = useState(dayjs());
// // // // //   const [recipientEmail, setRecipientEmail] = useState("");
// // // // //   const [reportMessage, setReportMessage] = useState("");
// // // // //   const [emailErrorKey, setEmailErrorKey] = useState("");

// // // // //   const validateEmail = (email) => {
// // // // //     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// // // // //     return emailRegex.test(email);
// // // // //   };

// // // // //   const handleEmailChange = (e) => {
// // // // //     const email = e.target.value;
// // // // //     setRecipientEmail(email);
// // // // //     if (email && !validateEmail(email)) {
// // // // //       setEmailErrorKey("validation.validEmail");
// // // // //     } else {
// // // // //       setEmailErrorKey("");
// // // // //     }
// // // // //   };

// // // // //   const clearForm = () => {
// // // // //     setPeriodType("month");
// // // // //     setSelectedDate(dayjs());
// // // // //     setRecipientEmail("");
// // // // //     setEmailErrorKey("");
// // // // //     setReportMessage("");
// // // // //     setExcelData([]);
// // // // //     setErrorKey(null);
// // // // //   };

// // // // //   // 🛠️ Updated to use the new Issues Export endpoint
// // // // //   const downloadExcel = () => {
// // // // //     setLoading(true);
// // // // //     setErrorKey(null);

// // // // //     axiosClient
// // // // //       .get("api/export-issues-excel/", { responseType: "blob" })
// // // // //       .then((response) => {
// // // // //         const url = window.URL.createObjectURL(new Blob([response.data]));
// // // // //         const link = document.createElement("a");
// // // // //         link.href = url;
// // // // //         link.setAttribute("download", `Issues_Report_${dayjs().format("DD-MM-YYYY")}.xlsx`);
// // // // //         document.body.appendChild(link);
// // // // //         link.click();
// // // // //         document.body.removeChild(link);
// // // // //         setLoading(false);
// // // // //       })
// // // // //       .catch(() => {
// // // // //         setErrorKey("excel.failedToDownloadFile");
// // // // //         setLoading(false);
// // // // //       });
// // // // //   };

// // // // //   // 🛠️ Updated to fetch and display the current Issues in the table
// // // // //   const displayData = () => {
// // // // //     setLoading(true);
// // // // //     setErrorKey(null);
// // // // //     setExcelData([]);

// // // // //     axiosClient
// // // // //       .get("api/export-issues-excel/", { responseType: "blob" })
// // // // //       .then((response) => {
// // // // //         const reader = new FileReader();
// // // // //         reader.onload = (e) => {
// // // // //           const data = new Uint8Array(e.target.result);
// // // // //           const workbook = XLSX.read(data, { type: "array" });
// // // // //           const worksheet = workbook.Sheets[workbook.SheetNames[0]];
// // // // //           const jsonData = XLSX.utils.sheet_to_json(worksheet);

// // // // //           setExcelData(jsonData);
// // // // //           setLoading(false);
// // // // //         };
// // // // //         reader.readAsArrayBuffer(response.data);
// // // // //       })
// // // // //       .catch(() => {
// // // // //         setErrorKey("excel.failedToLoadData");
// // // // //         setLoading(false);
// // // // //       });
// // // // //   };

// // // // //   const handleSendReport = () => {
// // // // //     if (!validateEmail(recipientEmail)) {
// // // // //       setEmailErrorKey("validation.validEmail");
// // // // //       return;
// // // // //     }

// // // // //     setLoading(true);
// // // // //     setReportMessage("");

// // // // //     let periodValue = periodType === "month" 
// // // // //         ? selectedDate.format("YYYY-MM") 
// // // // //         : `${selectedDate.format("YYYY")}-W${selectedDate.isoWeek()}`;

// // // // //     axiosClient
// // // // //       .post("/api/manual-sms/", { // 🛠️ Changed to manual-sms endpoint
// // // // //         phone: recipientEmail, // Logic depends on if your backend sends SMS or Email here
// // // // //         message: `Report for ${periodValue} requested.`,
// // // // //       })
// // // // //       .then((response) => {
// // // // //         setReportMessage(t("smsReport.success"));
// // // // //         setLoading(false);
// // // // //       })
// // // // //       .catch((err) => {
// // // // //         setReportMessage(t("smsReport.failedToSendReport"));
// // // // //         setLoading(false);
// // // // //       });
// // // // //   };

// // // // //   return (
// // // // //     <LocalizationProvider dateAdapter={AdapterDayjs}>
// // // // //       <Box sx={{ p: 3 }}>
// // // // //         <Typography variant="h5" align="center" gutterBottom sx={{ mb: 4, fontWeight: 'bold' }}>
// // // // //           {t("smsReport.title")}
// // // // //         </Typography>

// // // // //         <Paper elevation={4} sx={{ p: 3, mb: 4, borderRadius: 2 }}>
// // // // //           <Grid container spacing={3}>
// // // // //             <Grid item xs={12} sm={4}>
// // // // //               <FormControl fullWidth>
// // // // //                 <InputLabel>{t("smsReport.periodType")}</InputLabel>
// // // // //                 <Select
// // // // //                   value={periodType}
// // // // //                   onChange={(e) => setPeriodType(e.target.value)}
// // // // //                   label={t("smsReport.periodType")}
// // // // //                 >
// // // // //                   <MenuItem value="month">{t("smsReport.periodMonth")}</MenuItem>
// // // // //                   <MenuItem value="week">{t("smsReport.periodWeek")}</MenuItem>
// // // // //                 </Select>
// // // // //               </FormControl>
// // // // //             </Grid>

// // // // //             <Grid item xs={12} sm={4}>
// // // // //               <DatePicker
// // // // //                 label={periodType === "month" ? t("smsReport.selectMonth") : t("smsReport.selectWeek")}
// // // // //                 views={periodType === "month" ? ["year", "month"] : ["year", "month", "day"]}
// // // // //                 value={selectedDate}
// // // // //                 onChange={(newValue) => setSelectedDate(newValue)}
// // // // //                 slotProps={{ textField: { fullWidth: true } }}
// // // // //               />
// // // // //             </Grid>

// // // // //             <Grid item xs={12} sm={4}>
// // // // //               <TextField
// // // // //                 fullWidth
// // // // //                 label={t("smsReport.recipientEmail")}
// // // // //                 value={recipientEmail}
// // // // //                 onChange={handleEmailChange}
// // // // //                 error={!!emailErrorKey}
// // // // //                 helperText={emailErrorKey ? t(emailErrorKey) : ""}
// // // // //               />
// // // // //             </Grid>

// // // // //             <Grid item xs={12}>
// // // // //               <Box sx={{ display: "flex", gap: 2, justifyContent: "center", mt: 2 }}>
// // // // //                 <Button variant="contained" color="primary" onClick={displayData} disabled={loading}>
// // // // //                   {t("common.search") || "Search"}
// // // // //                 </Button>
// // // // //                 <Button variant="contained" color="secondary" onClick={handleSendReport} disabled={loading || !recipientEmail}>
// // // // //                   {t("smsReport.sendButton")}
// // // // //                 </Button>
// // // // //                 <Button variant="outlined" onClick={clearForm}>{t("common.clear")}</Button>
// // // // //               </Box>
// // // // //             </Grid>
// // // // //           </Grid>
// // // // //         </Paper>

// // // // //         <Card elevation={8} sx={{ borderRadius: 2 }}>
// // // // //           <CardContent>
// // // // //             <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
// // // // //               <Typography variant="h6">{t("excel.excelDataHeader")}</Typography>
// // // // //               <Button variant="contained" color="success" onClick={downloadExcel} disabled={loading}>
// // // // //                 {t("excel.downloadButton")}
// // // // //               </Button>
// // // // //             </Box>

// // // // //             {loading && (
// // // // //               <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}>
// // // // //                 <CircularProgress />
// // // // //               </Box>
// // // // //             )}

// // // // //             {errorKey && !loading && (
// // // // //               <Typography color="error" align="center">{t(errorKey)}</Typography>
// // // // //             )}

// // // // //             {reportMessage && (
// // // // //               <Typography align="center" sx={{ mb: 2 }} color={reportMessage.includes("fail") ? "error" : "primary"}>
// // // // //                 {reportMessage}
// // // // //               </Typography>
// // // // //             )}

// // // // //             {!loading && excelData.length > 0 && (
// // // // //               <TableContainer component={Paper} sx={{ maxHeight: 500, border: '1px solid rgba(224, 224, 224, 1)' }}>
// // // // //                 <Table stickyHeader>
// // // // //                   <TableHead>
// // // // //                     <TableRow>
// // // // //                       {Object.keys(excelData[0]).map((key) => (
// // // // //                         <TableCell key={key} sx={{ fontWeight: 'bold', bgcolor: 'background.default' }}>{key}</TableCell>
// // // // //                       ))}
// // // // //                     </TableRow>
// // // // //                   </TableHead>
// // // // //                   <TableBody>
// // // // //                     {excelData.map((row, index) => (
// // // // //                       <TableRow key={index} hover>
// // // // //                         {Object.values(row).map((val, i) => (
// // // // //                           <TableCell key={i}>{val}</TableCell>
// // // // //                         ))}
// // // // //                       </TableRow>
// // // // //                     ))}
// // // // //                   </TableBody>
// // // // //                 </Table>
// // // // //               </TableContainer>
// // // // //             )}
// // // // //           </CardContent>
// // // // //         </Card>
// // // // //       </Box>
// // // // //     </LocalizationProvider>
// // // // //   );
// // // // // }

// // // // // export default SendEmailSMS;



// // // // import { useState, useEffect } from "react";
// // // // import Typography from "@mui/material/Typography";
// // // // import CircularProgress from "@mui/material/CircularProgress";
// // // // import axiosClient from "../axiosClient";
// // // // import {
// // // //   Box,
// // // //   Button,
// // // //   CardContent,
// // // //   Table,
// // // //   TableCell,
// // // //   TableContainer,
// // // //   TableHead,
// // // //   TableRow,
// // // //   TextField,
// // // //   MenuItem,
// // // //   Select,
// // // //   InputLabel,
// // // //   FormControl,
// // // //   Grid,
// // // //   Card, 
// // // //   Paper, 
// // // //   TableBody,
// // // // } from "@mui/material";
// // // // import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// // // // import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// // // // import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// // // // import dayjs from "dayjs";
// // // // import isoWeek from "dayjs/plugin/isoWeek";
// // // // import { useTranslation } from "react-i18next";

// // // // dayjs.extend(isoWeek);

// // // // function SendEmailSMS() {
// // // //   const { t } = useTranslation();

// // // //   const [loading, setLoading] = useState(false);
// // // //   const [errorKey, setErrorKey] = useState(null);
// // // //   const [excelData, setExcelData] = useState([]);
// // // //   const [periodType, setPeriodType] = useState("month");
// // // //   const [selectedDate, setSelectedDate] = useState(dayjs());
// // // //   const [recipientEmail, setRecipientEmail] = useState("");
// // // //   const [reportMessage, setReportMessage] = useState("");
// // // //   const [emailErrorKey, setEmailErrorKey] = useState("");

// // // //   const validateEmail = (email) => {
// // // //     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// // // //     return emailRegex.test(email);
// // // //   };

// // // //   const handleEmailChange = (e) => {
// // // //     const email = e.target.value;
// // // //     setRecipientEmail(email);
// // // //     if (email && !validateEmail(email)) {
// // // //       setEmailErrorKey("validation.validEmail");
// // // //     } else {
// // // //       setEmailErrorKey("");
// // // //     }
// // // //   };

// // // //   const clearForm = () => {
// // // //     setPeriodType("month");
// // // //     setSelectedDate(dayjs());
// // // //     setRecipientEmail("");
// // // //     setEmailErrorKey("");
// // // //     setReportMessage("");
// // // //     setExcelData([]);
// // // //     setErrorKey(null);
// // // //   };

// // // //   const downloadExcel = () => {
// // // //     setLoading(true);
// // // //     setErrorKey(null);

// // // //     axiosClient
// // // //       .get("api/export-issues-excel/", { responseType: "blob" })
// // // //       .then((response) => {
// // // //         const url = window.URL.createObjectURL(new Blob([response.data]));
// // // //         const link = document.createElement("a");
// // // //         link.href = url;
// // // //         link.setAttribute("download", `Issues_Report_${dayjs().format("DD-MM-YYYY")}.xlsx`);
// // // //         document.body.appendChild(link);
// // // //         link.click();
// // // //         document.body.removeChild(link);
// // // //         setLoading(false);
// // // //       })
// // // //       .catch(() => {
// // // //         setErrorKey("excel.failedToDownloadFile");
// // // //         setLoading(false);
// // // //       });
// // // //   };

// // // //   // 🛠️ MODIFIED: Fetches JSON data directly for the screen table
// // // //   const displayData = () => {
// // // //     setLoading(true);
// // // //     setErrorKey(null);
// // // //     setExcelData([]);

// // // //     axiosClient
// // // //       .get("api/issue-list-data/") 
// // // //       .then((response) => {
// // // //         setExcelData(response.data); // JSON data fits directly into state
// // // //         setLoading(false);
// // // //       })
// // // //       .catch(() => {
// // // //         setErrorKey("excel.failedToLoadData");
// // // //         setLoading(false);
// // // //       });
// // // //   };

// // // //   const handleSendReport = () => {
// // // //     if (!validateEmail(recipientEmail)) {
// // // //       setEmailErrorKey("validation.validEmail");
// // // //       return;
// // // //     }

// // // //     setLoading(true);
// // // //     setReportMessage("");

// // // //     let periodValue = periodType === "month" 
// // // //         ? selectedDate.format("YYYY-MM") 
// // // //         : `${selectedDate.format("YYYY")}-W${selectedDate.isoWeek()}`;

// // // //     axiosClient
// // // //       .post("/api/manual-sms/", {
// // // //         phone: recipientEmail,
// // // //         message: `Report for ${periodValue} requested.`,
// // // //       })
// // // //       .then((response) => {
// // // //         setReportMessage(t("smsReport.success"));
// // // //         setLoading(false);
// // // //       })
// // // //       .catch((err) => {
// // // //         setReportMessage(t("smsReport.failedToSendReport"));
// // // //         setLoading(false);
// // // //       });
// // // //   };

// // // //   return (
// // // //     <LocalizationProvider dateAdapter={AdapterDayjs}>
// // // //       <Box sx={{ p: 3 }}>
// // // //         <Typography variant="h5" align="center" gutterBottom sx={{ mb: 4, fontWeight: 'bold' }}>
// // // //           {t("smsReport.title")}
// // // //         </Typography>

// // // //         <Paper elevation={4} sx={{ p: 3, mb: 4, borderRadius: 2 }}>
// // // //           <Grid container spacing={3}>
// // // //             <Grid item xs={12} sm={4}>
// // // //               <FormControl fullWidth>
// // // //                 <InputLabel>{t("smsReport.periodType")}</InputLabel>
// // // //                 <Select
// // // //                   value={periodType}
// // // //                   onChange={(e) => setPeriodType(e.target.value)}
// // // //                   label={t("smsReport.periodType")}
// // // //                 >
// // // //                   <MenuItem value="month">{t("smsReport.periodMonth")}</MenuItem>
// // // //                   <MenuItem value="week">{t("smsReport.periodWeek")}</MenuItem>
// // // //                 </Select>
// // // //               </FormControl>
// // // //             </Grid>

// // // //             <Grid item xs={12} sm={4}>
// // // //               <DatePicker
// // // //                 label={periodType === "month" ? t("smsReport.selectMonth") : t("smsReport.selectWeek")}
// // // //                 views={periodType === "month" ? ["year", "month"] : ["year", "month", "day"]}
// // // //                 value={selectedDate}
// // // //                 onChange={(newValue) => setSelectedDate(newValue)}
// // // //                 slotProps={{ textField: { fullWidth: true } }}
// // // //               />
// // // //             </Grid>

// // // //             <Grid item xs={12} sm={4}>
// // // //               <TextField
// // // //                 fullWidth
// // // //                 label={t("smsReport.recipientEmail")}
// // // //                 value={recipientEmail}
// // // //                 onChange={handleEmailChange}
// // // //                 error={!!emailErrorKey}
// // // //                 helperText={emailErrorKey ? t(emailErrorKey) : ""}
// // // //               />
// // // //             </Grid>

// // // //             <Grid item xs={12}>
// // // //               <Box sx={{ display: "flex", gap: 2, justifyContent: "center", mt: 2 }}>
// // // //                 <Button variant="contained" color="primary" onClick={displayData} disabled={loading}>
// // // //                   {t("common.search") || "Search"}
// // // //                 </Button>
// // // //                 <Button variant="contained" color="secondary" onClick={handleSendReport} disabled={loading || !recipientEmail}>
// // // //                   {t("smsReport.sendButton")}
// // // //                 </Button>
// // // //                 <Button variant="outlined" onClick={clearForm}>{t("common.clear")}</Button>
// // // //               </Box>
// // // //             </Grid>
// // // //           </Grid>
// // // //         </Paper>

// // // //         <Card elevation={8} sx={{ borderRadius: 2 }}>
// // // //           <CardContent>
// // // //             <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
// // // //               <Typography variant="h6">{t("excel.excelDataHeader")}</Typography>
// // // //               <Button variant="contained" color="success" onClick={downloadExcel} disabled={loading}>
// // // //                 {t("excel.downloadButton")}
// // // //               </Button>
// // // //             </Box>

// // // //             {loading && (
// // // //               <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}>
// // // //                 <CircularProgress />
// // // //               </Box>
// // // //             )}

// // // //             {errorKey && !loading && (
// // // //               <Typography color="error" align="center">{t(errorKey)}</Typography>
// // // //             )}

// // // //             {reportMessage && (
// // // //               <Typography align="center" sx={{ mb: 2 }} color={reportMessage.includes("fail") ? "error" : "primary"}>
// // // //                 {reportMessage}
// // // //               </Typography>
// // // //             )}

// // // //             {!loading && excelData.length > 0 && (
// // // //               <TableContainer component={Paper} sx={{ maxHeight: 500, border: '1px solid rgba(224, 224, 224, 1)' }}>
// // // //                 <Table stickyHeader>
// // // //                   <TableHead>
// // // //                     <TableRow>
// // // //                       {Object.keys(excelData[0]).map((key) => (
// // // //                         <TableCell key={key} sx={{ fontWeight: 'bold', bgcolor: 'background.default' }}>{key}</TableCell>
// // // //                       ))}
// // // //                     </TableRow>
// // // //                   </TableHead>
// // // //                   <TableBody>
// // // //                     {excelData.map((row, index) => (
// // // //                       <TableRow key={index} hover>
// // // //                         {Object.values(row).map((val, i) => (
// // // //                           <TableCell key={i}>{val}</TableCell>
// // // //                         ))}
// // // //                       </TableRow>
// // // //                     ))}
// // // //                   </TableBody>
// // // //                 </Table>
// // // //               </TableContainer>
// // // //             )}
// // // //           </CardContent>
// // // //         </Card>
// // // //       </Box>
// // // //     </LocalizationProvider>
// // // //   );
// // // // }

// // // // export default SendEmailSMS;

// // // import { useState } from "react";
// // // import {
// // //   Box, Button, CardContent, Table, TableCell, TableContainer,
// // //   TableHead, TableRow, TextField, MenuItem, Select, InputLabel,
// // //   FormControl, Grid, Card, Paper, TableBody, Typography, CircularProgress
// // // } from "@mui/material";
// // // import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
// // // import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// // // import axiosClient from "../axiosClient";
// // // import dayjs from "dayjs";
// // // import { useTranslation } from "react-i18next";

// // // function SendEmailSMS() {
// // //   const { t } = useTranslation();
// // //   const [loading, setLoading] = useState(false);
// // //   const [errorKey, setErrorKey] = useState(null);
// // //   const [tableData, setTableData] = useState([]); // Raw JSON data
// // //   const [periodType, setPeriodType] = useState("month");
// // //   const [selectedDate, setSelectedDate] = useState(dayjs());
// // //   const [recipientEmail, setRecipientEmail] = useState("");
// // //   const [reportMessage, setReportMessage] = useState("");

// // //   // 1. Fetch JSON data directly for the screen
// // //   const displayData = async () => {
// // //     setLoading(true);
// // //     setErrorKey(null);
// // //     try {
// // //       const response = await axiosClient.get("api/issue-list-data/");
// // //       setTableData(response.data);
// // //       setLoading(false);
// // //     } catch (err) {
// // //       setErrorKey("excel.failedToLoadData");
// // //       setLoading(false);
// // //     }
// // //   };

// // //   // 2. Original Download Excel logic
// // //   const downloadExcel = async () => {
// // //     setLoading(true);
// // //     try {
// // //       const response = await axiosClient.get("api/export-issues-excel/", { responseType: "blob" });
// // //       const url = window.URL.createObjectURL(new Blob([response.data]));
// // //       const link = document.createElement("a");
// // //       link.href = url;
// // //       link.setAttribute("download", `Report_${dayjs().format("DD-MM-YYYY")}.xlsx`);
// // //       document.body.appendChild(link);
// // //       link.click();
// // //       document.body.removeChild(link);
// // //       setLoading(false);
// // //     } catch (err) {
// // //       setErrorKey("excel.failedToDownloadFile");
// // //       setLoading(false);
// // //     }
// // //   };

// // //   const clearForm = () => {
// // //     setTableData([]);
// // //     setReportMessage("");
// // //     setRecipientEmail("");
// // //     setErrorKey(null);
// // //   };

// // //   return (
// // //     <LocalizationProvider dateAdapter={AdapterDayjs}>
// // //       <Box sx={{ p: 3 }}>
// // //         <Typography variant="h5" align="center" gutterBottom sx={{ mb: 4, fontWeight: 'bold' }}>
// // //           {t("smsReport.title")}
// // //         </Typography>

// // //         <Paper elevation={4} sx={{ p: 3, mb: 4 }}>
// // //           <Grid container spacing={3}>
// // //             <Grid item xs={12} sm={4}>
// // //               <FormControl fullWidth>
// // //                 <InputLabel>{t("smsReport.periodType")}</InputLabel>
// // //                 <Select value={periodType} onChange={(e) => setPeriodType(e.target.value)} label={t("smsReport.periodType")}>
// // //                   <MenuItem value="month">{t("smsReport.periodMonth")}</MenuItem>
// // //                   <MenuItem value="week">{t("smsReport.periodWeek")}</MenuItem>
// // //                 </Select>
// // //               </FormControl>
// // //             </Grid>

// // //             <Grid item xs={12} sm={4}>
// // //               <DatePicker
// // //                 label={periodType === "month" ? t("smsReport.selectMonth") : t("smsReport.selectWeek")}
// // //                 value={selectedDate}
// // //                 onChange={(newValue) => setSelectedDate(newValue)}
// // //                 slotProps={{ textField: { fullWidth: true } }}
// // //               />
// // //             </Grid>

// // //             <Grid item xs={12} sm={4}>
// // //               <TextField fullWidth label={t("smsReport.recipientEmail")} value={recipientEmail} onChange={(e) => setRecipientEmail(e.target.value)} />
// // //             </Grid>

// // //             <Grid item xs={12} sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
// // //               <Button variant="contained" onClick={displayData} disabled={loading}>{t("common.search") || "Search"}</Button>
// // //               <Button variant="outlined" onClick={clearForm}>{t("common.clear") || "Clear"}</Button>
// // //             </Grid>
// // //           </Grid>
// // //         </Paper>

// // //         <Card elevation={8}>
// // //           <CardContent>
// // //             <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
// // //               <Typography variant="h6">{t("excel.excelDataHeader")}</Typography>
// // //               <Button variant="contained" color="success" onClick={downloadExcel} disabled={loading}>{t("excel.downloadButton")}</Button>
// // //             </Box>

// // //             {loading ? (
// // //               <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}><CircularProgress /></Box>
// // //             ) : errorKey ? 
// // //             (
// // //               <Typography color="error" align="center">{t(errorKey)}</Typography>
// // //             ) : tableData.length > 0 ? (
// // //               <TableContainer component={Paper} sx={{ maxHeight: 500 }}>
// // //                 <Table stickyHeader>
// // //                   <TableHead>
// // //                     <TableRow>
// // //                       {Object.keys(tableData[0]).map((key) => (
// // //                         <TableCell key={key} sx={{ fontWeight: 'bold', bgcolor: 'grey.200' }}>{key}</TableCell>
// // //                       ))}
// // //                     </TableRow>
// // //                   </TableHead>
// // //                   <TableBody>
// // //                     {tableData.map((row, index) => (
// // //                       <TableRow key={index} hover>
// // //                         {Object.values(row).map((val, i) => (
// // //                           <TableCell key={i}>{val}</TableCell>
// // //                         ))}
// // //                       </TableRow>
// // //                     ))}
// // //                   </TableBody>
// // //                 </Table>
// // //               </TableContainer>
// // //             ) : (
// // //                <Typography align="center" color="text.secondary">{t("reports.noDataForPeriod")}</Typography>
// // //             )}
// // //           </CardContent>
// // //         </Card>
// // //       </Box>
// // //     </LocalizationProvider>
// // //   );
// // // }

// // // export default SendEmailSMS;



// // import { useState } from "react";
// // import {
// //   Box, Button, CardContent, Table, TableCell, TableContainer,
// //   TableHead, TableRow, TextField, MenuItem, Select, InputLabel,
// //   FormControl, Grid, Card, Paper, TableBody, Typography, CircularProgress
// // } from "@mui/material";
// // import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
// // import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// // import axiosClient from "../axiosClient";
// // import dayjs from "dayjs";
// // import isoWeek from "dayjs/plugin/isoWeek";
// // import { useTranslation } from "react-i18next";

// // dayjs.extend(isoWeek);

// // function SendEmailSMS() {
// //   const { t } = useTranslation();
// //   const [loading, setLoading] = useState(false);
// //   const [errorKey, setErrorKey] = useState(null);
// //   const [tableData, setTableData] = useState([]); 
// //   const [periodType, setPeriodType] = useState("month");
// //   const [selectedDate, setSelectedDate] = useState(dayjs());
// //   const [recipientEmail, setRecipientEmail] = useState("");
// //   const [reportMessage, setReportMessage] = useState("");

// //   // 🛠️ 1. Fetch JSON data with Date Filtering
// //   const displayData = async () => {
// //     setLoading(true);
// //     setErrorKey(null);
    
// //     // Calculate start and end dates based on user selection
// //     let start, end;
// //     if (periodType === "month") {
// //         start = selectedDate.startOf('month').format("YYYY-MM-DD");
// //         end = selectedDate.endOf('month').format("YYYY-MM-DD");
// //     } else {
// //         start = selectedDate.startOf('isoWeek').format("YYYY-MM-DD");
// //         end = selectedDate.endOf('isoWeek').format("YYYY-MM-DD");
// //     }

// //     try {
// //       // Send the start and end dates as query parameters
// //       const response = await axiosClient.get("api/issue-list-data/", {
// //           params: { start, end }
// //       });
// //       setTableData(response.data);
// //       setLoading(false);
// //     } catch (err) {
// //       console.error("Fetch error:", err);
// //       setErrorKey("excel.failedToLoadData");
// //       setLoading(false);
// //     }
// //   };

// //   // 🛠️ 2. Download Excel Logic
// //   const downloadExcel = async () => {
// //     setLoading(true);
// //     try {
// //       const response = await axiosClient.get("api/export-issues-excel/", { responseType: "blob" });
// //       const url = window.URL.createObjectURL(new Blob([response.data]));
// //       const link = document.createElement("a");
// //       link.href = url;
// //       link.setAttribute("download", `Issues_Report_${dayjs().format("DD-MM-YYYY")}.xlsx`);
// //       document.body.appendChild(link);
// //       link.click();
// //       document.body.removeChild(link);
// //       setLoading(false);
// //     } catch (err) {
// //       setErrorKey("excel.failedToDownloadFile");
// //       setLoading(false);
// //     }
// //   };

// //   const handleSendReport = async () => {
// //     if (!recipientEmail) return;
// //     setLoading(true);
// //     try {
// //       const response = await axiosClient.post("/api/manual-sms/", {
// //         phone: recipientEmail,
// //         message: `Report requested for ${selectedDate.format("MMMM YYYY")}`,
// //       });
// //       setReportMessage(t("smsReport.success"));
// //       setLoading(false);
// //     } catch (err) {
// //       setReportMessage(t("smsReport.failedToSendReport"));
// //       setLoading(false);
// //     }
// //   };

// //   const clearForm = () => {
// //     setTableData([]);
// //     setReportMessage("");
// //     setRecipientEmail("");
// //     setErrorKey(null);
// //   };

// //   return (
// //     <LocalizationProvider dateAdapter={AdapterDayjs}>
// //       <Box sx={{ p: 3 }}>
// //         <Typography variant="h5" align="center" gutterBottom sx={{ mb: 4, fontWeight: 'bold' }}>
// //           {t("smsReport.title")}
// //         </Typography>

// //         <Paper elevation={4} sx={{ p: 3, mb: 4, bgcolor: 'background.paper' }}>
// //           <Grid container spacing={3}>
// //             <Grid item xs={12} sm={4}>
// //               <FormControl fullWidth>
// //                 <InputLabel>{t("smsReport.periodType")}</InputLabel>
// //                 <Select 
// //                   value={periodType} 
// //                   onChange={(e) => setPeriodType(e.target.value)} 
// //                   label={t("smsReport.periodType")}
// //                 >
// //                   <MenuItem value="month">{t("smsReport.periodMonth")}</MenuItem>
// //                   <MenuItem value="week">{t("smsReport.periodWeek")}</MenuItem>
// //                 </Select>
// //               </FormControl>
// //             </Grid>

// //             <Grid item xs={12} sm={4}>
// //               <DatePicker
// //                 label={periodType === "month" ? t("smsReport.selectMonth") : t("smsReport.selectWeek")}
// //                 value={selectedDate}
// //                 onChange={(newValue) => setSelectedDate(newValue)}
// //                 views={periodType === "month" ? ["year", "month"] : ["year", "month", "day"]}
// //                 slotProps={{ textField: { fullWidth: true } }}
// //               />
// //             </Grid>

// //             <Grid item xs={12} sm={4}>
// //               <TextField 
// //                 fullWidth 
// //                 label={t("smsReport.recipientEmail")} 
// //                 value={recipientEmail} 
// //                 onChange={(e) => setRecipientEmail(e.target.value)} 
// //               />
// //             </Grid>

// //             <Grid item xs={12} sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
// //               <Button variant="contained" color="primary" onClick={displayData} disabled={loading}>
// //                 {t("common.presentData") || "PRESENT DATA"}
// //               </Button>
// //               <Button variant="contained" color="secondary" onClick={handleSendReport} disabled={loading || !recipientEmail}>
// //                 {t("smsReport.sendButton")}
// //               </Button>
// //               <Button variant="outlined" onClick={clearForm}>
// //                 {t("common.clear") || "Clear"}
// //               </Button>
// //             </Grid>
// //           </Grid>
// //         </Paper>

// //         <Card elevation={8}>
// //           <CardContent>
// //             <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
// //               <Typography variant="h6">{t("excel.excelDataHeader")}</Typography>
// //               <Button 
// //                 variant="contained" 
// //                 color="success" 
// //                 onClick={downloadExcel} 
// //                 disabled={loading || tableData.length === 0}
// //               >
// //                 {t("excel.downloadButton")}
// //               </Button>
// //             </Box>

// //             {loading ? (
// //               <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}><CircularProgress /></Box>
// //             ) : errorKey ? (
// //               <Typography color="error" align="center">{t(errorKey)}</Typography>
// //             ) : tableData.length > 0 ? (
// //               <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
// //                 <Table stickyHeader>
// //                   <TableHead>
// //                     <TableRow>
// //                       {Object.keys(tableData[0]).map((key) => (
// //                         <TableCell key={key} sx={{ fontWeight: 'bold', bgcolor: 'background.default' }}>
// //                           {key}
// //                         </TableCell>
// //                       ))}
// //                     </TableRow>
// //                   </TableHead>
// //                   <TableBody>
// //                     {tableData.map((row, index) => (
// //                       <TableRow key={index} hover>
// //                         {Object.values(row).map((val, i) => (
// //                           <TableCell key={i}>{val}</TableCell>
// //                         ))}
// //                       </TableRow>
// //                     ))}
// //                   </TableBody>
// //                 </Table>
// //               </TableContainer>
// //             ) : (
// //                <Box sx={{ p: 4, textAlign: 'center' }}>
// //                  <Typography color="text.secondary">{t("reports.noDataForPeriod")}</Typography>
// //                </Box>
// //             )}
// //           </CardContent>
// //         </Card>
// //       </Box>
// //     </LocalizationProvider>
// //   );
// // }

// // export default SendEmailSMS;

// ///////////////////////////////////////////////////////////////////////////////////////////////////////////////

// // import { useState } from "react";
// // import {
// //   Box, Button, CardContent, Table, TableCell, TableContainer,
// //   TableHead, TableRow, TextField, MenuItem, Select, InputLabel,
// //   FormControl, Grid, Card, Paper, TableBody, Typography, CircularProgress
// // } from "@mui/material";
// // import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
// // import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// // import axiosClient from "../axiosClient";
// // import dayjs from "dayjs";
// // import isoWeek from "dayjs/plugin/isoWeek";
// // import { useTranslation } from "react-i18next";

// // dayjs.extend(isoWeek);

// // function SendEmailSMS() {
// //   const { t } = useTranslation();
// //   const [loading, setLoading] = useState(false);
// //   const [errorKey, setErrorKey] = useState(null);
// //   const [tableData, setTableData] = useState([]); 
// //   const [periodType, setPeriodType] = useState("month");
// //   const [selectedDate, setSelectedDate] = useState(dayjs());
// //   const [recipientEmail, setRecipientEmail] = useState("");

// //   const displayData = async () => {
// //     setLoading(true);
// //     setErrorKey(null);
    
// //     let start, end;
// //     if (periodType === "month") {
// //         start = selectedDate.startOf('month').format("YYYY-MM-DD");
// //         end = selectedDate.endOf('month').format("YYYY-MM-DD");
// //     } else {
// //         start = selectedDate.startOf('isoWeek').format("YYYY-MM-DD");
// //         end = selectedDate.endOf('isoWeek').format("YYYY-MM-DD");
// //     }

// //     try {
// //       const response = await axiosClient.get("api/issue-list-data/", {
// //           params: { start, end }
// //       });
// //       setTableData(response.data);
// //       setLoading(false);
// //     } catch (err) {
// //       setErrorKey("excel.failedToLoadData");
// //       setLoading(false);
// //     }
// //   };

// //   const downloadExcel = async () => {
// //     setLoading(true);
// //     try {
// //       const response = await axiosClient.get("api/export-issues-excel/", { responseType: "blob" });
// //       const url = window.URL.createObjectURL(new Blob([response.data]));
// //       const link = document.createElement("a");
// //       link.href = url;
// //       link.setAttribute("download", `Issues_Report_${dayjs().format("DD-MM-YYYY")}.xlsx`);
// //       document.body.appendChild(link);
// //       link.click();
// //       document.body.removeChild(link);
// //       setLoading(false);
// //     } catch (err) {
// //       setErrorKey("excel.failedToDownloadFile");
// //       setLoading(false);
// //     }
// //   };

// //   return (
// //     <LocalizationProvider dateAdapter={AdapterDayjs}>
// //       <Box sx={{ p: 3 }}>
// //         <Typography variant="h5" align="center" gutterBottom sx={{ mb: 4, fontWeight: 'bold' }}>
// //           {t("smsReport.title")}
// //         </Typography>

// //         <Paper elevation={4} sx={{ p: 3, mb: 4 }}>
// //           <Grid container spacing={3}>
// //             <Grid item xs={12} sm={4}>
// //               <FormControl fullWidth>
// //                 <InputLabel>{t("smsReport.periodType")}</InputLabel>
// //                 <Select value={periodType} onChange={(e) => setPeriodType(e.target.value)} label={t("smsReport.periodType")}>
// //                   <MenuItem value="month">{t("smsReport.periodMonth")}</MenuItem>
// //                   <MenuItem value="week">{t("smsReport.periodWeek")}</MenuItem>
// //                 </Select>
// //               </FormControl>
// //             </Grid>

// //             <Grid item xs={12} sm={4}>
// //               <DatePicker
// //                 label={periodType === "month" ? t("smsReport.selectMonth") : t("smsReport.selectWeek")}
// //                 value={selectedDate}
// //                 onChange={(newValue) => setSelectedDate(newValue)}
// //                 slotProps={{ textField: { fullWidth: true } }}
// //               />
// //             </Grid>

// //             <Grid item xs={12} sm={4}>
// //               <TextField fullWidth label={t("smsReport.recipientEmail")} value={recipientEmail} onChange={(e) => setRecipientEmail(e.target.value)} />
// //             </Grid>

// //             <Grid item xs={12} sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
// //               {/* 🛠️ BUTTON UPDATED HERE */}
// //               <Button variant="contained" color="primary" onClick={displayData} disabled={loading}>
// //                 {t("common.presentData") || "PRESENT DATA"}
// //               </Button>
// //               <Button variant="outlined" onClick={() => setTableData([])}>{t("common.clear") || "Clear"}</Button>
// //             </Grid>
// //           </Grid>
// //         </Paper>

// //         <Card elevation={8}>
// //           <CardContent>
// //             <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
// //               <Typography variant="h6">{t("excel.excelDataHeader")}</Typography>
// //               <Button variant="contained" color="success" onClick={downloadExcel} disabled={loading}>{t("excel.downloadButton")}</Button>
// //             </Box>

// //             {loading ? (
// //               <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}><CircularProgress /></Box>
// //             ) : tableData.length > 0 ? (
// //               <TableContainer component={Paper} sx={{ maxHeight: 500 }}>
// //                 <Table stickyHeader>
// //                   <TableHead>
// //                     <TableRow>
// //                       {Object.keys(tableData[0]).map((key) => (
// //                         <TableCell key={key} sx={{ fontWeight: 'bold', bgcolor: 'background.default' }}>{key}</TableCell>
// //                       ))}
// //                     </TableRow>
// //                   </TableHead>
// //                   <TableBody>
// //                     {tableData.map((row, index) => (
// //                       <TableRow key={index} hover>
// //                         {Object.values(row).map((val, i) => (
// //                           <TableCell key={i}>{val}</TableCell>
// //                         ))}
// //                       </TableRow>
// //                     ))}
// //                   </TableBody>
// //                 </Table>
// //               </TableContainer>
// //             ) : (
// //                <Typography align="center" sx={{ py: 4 }} color="text.secondary">{t("reports.noDataForPeriod")}</Typography>
// //             )}
// //           </CardContent>
// //         </Card>
// //       </Box>
// //     </LocalizationProvider>
// //   );
// // }

// // export default SendEmailSMS;

// /////////////////////////////////////////////////////////////////////////////////////

// import { useState } from "react";
// import {
//   Box, Button, CardContent, Table, TableCell, TableContainer,
//   TableHead, TableRow, TextField, MenuItem, Select, InputLabel,
//   FormControl, Grid, Card, Paper, TableBody, Typography, CircularProgress
// } from "@mui/material";
// import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import axiosClient from "../axiosClient";
// import dayjs from "dayjs";
// import isoWeek from "dayjs/plugin/isoWeek";
// import { useTranslation } from "react-i18next";

// dayjs.extend(isoWeek);

// function SendEmailSMS() {
//   const { t } = useTranslation();
//   const [loading, setLoading] = useState(false);
//   const [errorKey, setErrorKey] = useState(null);
//   const [tableData, setTableData] = useState([]); 
//   const [periodType, setPeriodType] = useState("month");
//   const [selectedDate, setSelectedDate] = useState(dayjs());
//   const [recipientEmail, setRecipientEmail] = useState("");

//   // ✅ Helper function to rename headers
//   const getHeaderLabel = (key) => {
//     const labels = {
//       room_number: "Room Number",
//       staff_name: "Staff Name",
//       finish_time: "Finish Time",
//       tech_color: "Tech Color",
//       appt_start: "Appt Start",
//       scheduled_end: "Scheduled End",
//       assigned_technician: "Assigned Technician",
//       closed_by_admin: "Close by Admin/Reception",
//       // Keep others as they are if not specified
//       id: "ID",
//       title: "Title",
//       status: "Status",
//       reported: "Reported"
//     };
//     return labels[key] || key;
//   };

//   const displayData = async () => {
//     setLoading(true);
//     setErrorKey(null);
    
//     let start, end;
//     if (periodType === "month") {
//         start = selectedDate.startOf('month').format("YYYY-MM-DD");
//         end = selectedDate.endOf('month').format("YYYY-MM-DD");
//     } else {
//         start = selectedDate.startOf('isoWeek').format("YYYY-MM-DD");
//         end = selectedDate.endOf('isoWeek').format("YYYY-MM-DD");
//     }

//     try {
//       const response = await axiosClient.get("api/issue-list-data/", {
//           params: { start, end }
//       });
//       setTableData(response.data);
//       setLoading(false);
//     } catch (err) {
//       setErrorKey("excel.failedToLoadData");
//       setLoading(false);
//     }
//   };

//   const downloadExcel = async () => {
//     setLoading(true);
//     try {
//       const response = await axiosClient.get("api/export-issues-excel/", { responseType: "blob" });
//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", `Issues_Report_${dayjs().format("DD-MM-YYYY")}.xlsx`);
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       setLoading(false);
//     } catch (err) {
//       setErrorKey("excel.failedToDownloadFile");
//       setLoading(false);
//     }
//   };

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <Box sx={{ p: 3 }}>
//         <Typography variant="h5" align="center" gutterBottom sx={{ mb: 4, fontWeight: 'bold' }}>
//           {t("smsReport.title")}
//         </Typography>

//         <Paper elevation={4} sx={{ p: 3, mb: 4 }}>
//           <Grid container spacing={3}>
//             <Grid item xs={12} sm={4}>
//               <FormControl fullWidth>
//                 <InputLabel>{t("smsReport.periodType")}</InputLabel>
//                 <Select value={periodType} onChange={(e) => setPeriodType(e.target.value)} label={t("smsReport.periodType")}>
//                   <MenuItem value="month">{t("smsReport.periodMonth")}</MenuItem>
//                   <MenuItem value="week">{t("smsReport.periodWeek")}</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12} sm={4}>
//               <DatePicker
//                 label={periodType === "month" ? t("smsReport.selectMonth") : t("smsReport.selectWeek")}
//                 value={selectedDate}
//                 onChange={(newValue) => setSelectedDate(newValue)}
//                 slotProps={{ textField: { fullWidth: true } }}
//               />
//             </Grid>

//             <Grid item xs={12} sm={4}>
//               <TextField fullWidth label={t("smsReport.recipientEmail")} value={recipientEmail} onChange={(e) => setRecipientEmail(e.target.value)} />
//             </Grid>

//             <Grid item xs={12} sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
//               <Button variant="contained" color="primary" onClick={displayData} disabled={loading}>
//                 {t("common.presentData") || "PRESENT DATA"}
//               </Button>
//               <Button variant="outlined" onClick={() => setTableData([])}>{t("common.clear") || "Clear"}</Button>
//             </Grid>
//           </Grid>
//         </Paper>

//         <Card elevation={8}>
//           <CardContent>
//             <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
//               <Typography variant="h6">{t("excel.excelDataHeader")}</Typography>
//               <Button variant="contained" color="success" onClick={downloadExcel} disabled={loading}>{t("excel.downloadButton")}</Button>
//             </Box>

//             {loading ? (
//               <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}><CircularProgress /></Box>
//             ) : tableData.length > 0 ? (
//               <TableContainer component={Paper} sx={{ maxHeight: 500 }}>
//                 <Table stickyHeader>
//                   <TableHead>
//                     <TableRow>
//                       {Object.keys(tableData[0]).map((key) => (
//                         <TableCell key={key} sx={{ fontWeight: 'bold', bgcolor: 'background.default', whiteSpace: 'nowrap' }}>
//                           {/* ✅ Header label is now processed through the helper function */}
//                           {getHeaderLabel(key)}
//                         </TableCell>
//                       ))}
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {tableData.map((row, index) => (
//                       <TableRow key={index} hover>
//                         {Object.values(row).map((val, i) => (
//                           <TableCell key={i}>{val}</TableCell>
//                         ))}
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             ) : (
//                <Typography align="center" sx={{ py: 4 }} color="text.secondary">{t("reports.noDataForPeriod")}</Typography>
//             )}
//           </CardContent>
//         </Card>
//       </Box>
//     </LocalizationProvider>
//   );
// }

// export default SendEmailSMS;



//////////////////////////////////////////////////////////////////////////////////////////////////

// import { useState } from "react";
// import {
//   Box, Button, CardContent, Table, TableCell, TableContainer,
//   TableHead, TableRow, TextField, MenuItem, Select, InputLabel,
//   FormControl, Grid, Card, Paper, TableBody, Typography, CircularProgress
// } from "@mui/material";
// import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import axiosClient from "../axiosClient";
// import dayjs from "dayjs";
// import isoWeek from "dayjs/plugin/isoWeek";
// import { useTranslation } from "react-i18next";

// dayjs.extend(isoWeek);

// function SendEmailSMS() {
//   const { t } = useTranslation();
//   const [loading, setLoading] = useState(false);
//   const [errorKey, setErrorKey] = useState(null);
//   const [tableData, setTableData] = useState([]); 
//   const [periodType, setPeriodType] = useState("month");
//   const [selectedDate, setSelectedDate] = useState(dayjs());
//   const [recipientEmail, setRecipientEmail] = useState("");

//   const getHeaderLabel = (key) => {
//     const labels = {
//       id: "ID",
//       room_number: "Room Number",
//       title: "Title",
//       status: "Status",
//       reported: "Reported",
//       staff_name: "Staff Name",
//       finish_time: "Finish Time",
//       tech_color: "Tech Color",
//       appt_start: "Appt Start",
//       scheduled_end: "Scheduled End",
//       assigned_technician: "Assigned Technician",
//       closed_by_admin: "Close by", 
//     };
//     return labels[key] || key;
//   };

//   const displayData = async () => {
//     setLoading(true);
//     setErrorKey(null);
//     let start, end;
//     if (periodType === "month") {
//         start = selectedDate.startOf('month').format("YYYY-MM-DD");
//         end = selectedDate.endOf('month').format("YYYY-MM-DD");
//     } else {
//         start = selectedDate.startOf('isoWeek').format("YYYY-MM-DD");
//         end = selectedDate.endOf('isoWeek').format("YYYY-MM-DD");
//     }

//     try {
//       const response = await axiosClient.get("api/issue-list-data/", {
//           params: { start, end }
//       });
//       setTableData(response.data);
//       setLoading(false);
//     } catch (err) {
//       setErrorKey("excel.failedToLoadData");
//       setLoading(false);
//     }
//   };

//   const downloadExcel = async () => {
//     setLoading(true);
//     try {
//       const response = await axiosClient.get("api/export-issues-excel/", { responseType: "blob" });
//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", `Issues_Report_${dayjs().format("DD-MM-YYYY")}.xlsx`);
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       setLoading(false);
//     } catch (err) {
//       setErrorKey("excel.failedToDownloadFile");
//       setLoading(false);
//     }
//   };

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <Box sx={{ p: 3 }}>
//         <Typography variant="h5" align="center" gutterBottom sx={{ mb: 4, fontWeight: 'bold' }}>
//           {t("smsReport.title")}
//         </Typography>

//         <Paper elevation={4} sx={{ p: 3, mb: 4 }}>
//           <Grid container spacing={3}>
//             <Grid item xs={12} sm={4}>
//               <FormControl fullWidth>
//                 <InputLabel>{t("smsReport.periodType")}</InputLabel>
//                 <Select value={periodType} onChange={(e) => setPeriodType(e.target.value)} label={t("smsReport.periodType")}>
//                   <MenuItem value="month">{t("smsReport.periodMonth")}</MenuItem>
//                   <MenuItem value="week">{t("smsReport.periodWeek")}</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <DatePicker
//                 label={periodType === "month" ? t("smsReport.selectMonth") : t("smsReport.selectWeek")}
//                 value={selectedDate}
//                 onChange={(newValue) => setSelectedDate(newValue)}
//                 slotProps={{ textField: { fullWidth: true } }}
//               />
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <TextField fullWidth label={t("smsReport.recipientEmail")} value={recipientEmail} onChange={(e) => setRecipientEmail(e.target.value)} />
//             </Grid>
//             <Grid item xs={12} sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
//               <Button variant="contained" color="primary" onClick={displayData} disabled={loading}>
//                 {t("common.presentData") || "PRESENT DATA"}
//               </Button>
//               <Button variant="outlined" onClick={() => setTableData([])}>{t("common.clear") || "Clear"}</Button>
//             </Grid>
//           </Grid>
//         </Paper>

//         <Card elevation={8}>
//           <CardContent>
//             <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
//               <Typography variant="h6">{t("excel.excelDataHeader")}</Typography>
//               <Button variant="contained" color="success" onClick={downloadExcel} disabled={loading}>{t("excel.downloadButton")}</Button>
//             </Box>

//             {loading ? (
//               <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}><CircularProgress /></Box>
//             ) : tableData.length > 0 ? (
//               <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
//                 <Table stickyHeader>
//                   <TableHead>
//                     <TableRow>
//                       {Object.keys(tableData[0]).map((key) => (
//                         <TableCell key={key} sx={{ fontWeight: 'bold', bgcolor: 'background.default', whiteSpace: 'nowrap' }}>
//                           {getHeaderLabel(key)}
//                         </TableCell>
//                       ))}
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {tableData.map((row, index) => (
//                       <TableRow key={index} hover>
//                         {Object.entries(row).map(([key, val], i) => {
                          
//                           // ✅ CRITICAL FIX: Checking for key "closed_by_admin"
//                           if (key === "closed_by_admin") {
//                             // If the field is totally empty, show nothing
//                             if (!val || val === "" || val === "null") {
//                               return <TableCell key={i}></TableCell>;
//                             }

//                             const upperVal = String(val).toUpperCase();
//                             // If role is ADMIN or RECEPTION, show the name
//                             if (upperVal.includes("ADMIN") || upperVal.includes("RECEPTION")) {
//                               return <TableCell key={i}>{val}</TableCell>;
//                             } 
//                             // If anyone else (Maid/Tech) closed it, show X
//                             else {
//                               return <TableCell key={i} align="center" sx={{ fontWeight: 'bold', color: 'red', fontSize: '1.2rem' }}>X</TableCell>;
//                             }
//                           }

//                           return <TableCell key={i}>{val}</TableCell>;
//                         })}
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             ) : (
//                <Typography align="center" sx={{ py: 4 }} color="text.secondary">{t("reports.noDataForPeriod")}</Typography>
//             )}
//           </CardContent>
//         </Card>
//       </Box>
//     </LocalizationProvider>
//   );
// }

// export default SendEmailSMS;



//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// import { useState } from "react";
// import {
//   Box, Button, CardContent, Table, TableCell, TableContainer,
//   TableHead, TableRow, TextField, MenuItem, Select, InputLabel,
//   FormControl, Grid, Card, Paper, TableBody, Typography, CircularProgress
// } from "@mui/material";
// import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import axiosClient from "../axiosClient";
// import dayjs from "dayjs";
// import isoWeek from "dayjs/plugin/isoWeek";
// import { useTranslation } from "react-i18next";

// dayjs.extend(isoWeek);

// function SendEmailSMS() {
//   const { t } = useTranslation();
//   const [loading, setLoading] = useState(false);
//   const [tableData, setTableData] = useState([]); 
//   const [periodType, setPeriodType] = useState("month");
//   const [selectedDate, setSelectedDate] = useState(dayjs());
//   const [recipientEmail, setRecipientEmail] = useState("");

//   const getHeaderLabel = (key) => {
//     const labels = {
//       id: "ID",
//       room_number: "Room Number",
//       title: "Title",
//       status: "Status",
//       reported: "Reported",
//       staff_name: "Staff Name",
//       finish_time: "Finish Time",
//       tech_color: "Tech Color",
//       appt_start: "Appt Start",
//       scheduled_end: "Scheduled End",
//       assigned_technician: "Assigned Technician",
//       closed_by_admin: "Close by Admin/Reception", 
//     };
//     return labels[key] || key;
//   };

//   const displayData = async () => {
//     setLoading(true);
//     let start = selectedDate.startOf(periodType === "month" ? 'month' : 'isoWeek').format("YYYY-MM-DD");
//     let end = selectedDate.endOf(periodType === "month" ? 'month' : 'isoWeek').format("YYYY-MM-DD");

//     try {
//       const response = await axiosClient.get("api/issue-list-data/", { params: { start, end } });
//       setTableData(response.data);
//     } catch (err) {
//       console.error("Data fetch failed", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <Box sx={{ p: 3 }}>
//         <Typography variant="h5" align="center" gutterBottom sx={{ mb: 4, fontWeight: 'bold' }}>
//           {t("smsReport.title")}
//         </Typography>

//         <Paper elevation={4} sx={{ p: 3, mb: 4 }}>
//           <Grid container spacing={3}>
//             <Grid item xs={12} sm={4}>
//               <FormControl fullWidth>
//                 <InputLabel>{t("smsReport.periodType")}</InputLabel>
//                 <Select value={periodType} onChange={(e) => setPeriodType(e.target.value)} label={t("smsReport.periodType")}>
//                   <MenuItem value="month">{t("smsReport.periodMonth")}</MenuItem>
//                   <MenuItem value="week">{t("smsReport.periodWeek")}</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <DatePicker
//                 label={periodType === "month" ? t("smsReport.selectMonth") : t("smsReport.selectWeek")}
//                 value={selectedDate}
//                 onChange={(newValue) => setSelectedDate(newValue)}
//                 slotProps={{ textField: { fullWidth: true } }}
//               />
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <TextField fullWidth label={t("smsReport.recipientEmail")} value={recipientEmail} onChange={(e) => setRecipientEmail(e.target.value)} />
//             </Grid>
//             <Grid item xs={12} sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
//               <Button variant="contained" onClick={displayData} disabled={loading}>PRESENT DATA</Button>
//               <Button variant="outlined" onClick={() => setTableData([])}>Clear</Button>
//             </Grid>
//           </Grid>
//         </Paper>

//         <Card elevation={8}>
//           <CardContent>
//             {loading ? (
//               <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}><CircularProgress /></Box>
//             ) : tableData.length > 0 ? (
//               <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
//                 <Table stickyHeader>
//                   <TableHead>
//                     <TableRow>
//                       {Object.keys(tableData[0]).map((key) => (
//                         <TableCell key={key} sx={{ fontWeight: 'bold', bgcolor: 'background.default' }}>
//                           {getHeaderLabel(key)}
//                         </TableCell>
//                       ))}
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {tableData.map((row, index) => (
//                       <TableRow key={index} hover>
//                         {Object.entries(row).map(([key, val], i) => {
                          
//                           // ✅ REVISED LOGIC
//                           if (key === "closed_by_admin") {
//                             const rawValue = val ? String(val).toUpperCase() : "";
                            
//                             // Check if it's an Admin or Receptionist
//                             if (rawValue.includes("ADMIN") || rawValue.includes("RECEPTION")) {
//                               return <TableCell key={i}>{val}</TableCell>;
//                             } 
                            
//                             // For ANY other case (including blank/null), show X
//                             else {
//                               return <TableCell key={i} align="center" sx={{ color: 'red', fontWeight: 'bold', fontSize: '1.2rem' }}>X</TableCell>;
//                             }
//                           }

//                           return <TableCell key={i}>{val}</TableCell>;
//                         })}
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             ) : (
//                <Typography align="center" sx={{ py: 4 }}>No data found.</Typography>
//             )}
//           </CardContent>
//         </Card>
//       </Box>
//     </LocalizationProvider>
//   );
// }

// export default SendEmailSMS;


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////


// import { useState } from "react";
// import {
//   Box, Button, CardContent, Table, TableCell, TableContainer,
//   TableHead, TableRow, TextField, MenuItem, Select, InputLabel,
//   FormControl, Grid, Card, Paper, TableBody, Typography, CircularProgress
// } from "@mui/material";
// import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import axiosClient from "../axiosClient";
// import dayjs from "dayjs";
// import isoWeek from "dayjs/plugin/isoWeek";
// import { useTranslation } from "react-i18next";

// dayjs.extend(isoWeek);

// function SendEmailSMS() {
//   const { t } = useTranslation();
//   const [loading, setLoading] = useState(false);
//   const [tableData, setTableData] = useState([]); 
//   const [periodType, setPeriodType] = useState("month");
//   const [selectedDate, setSelectedDate] = useState(dayjs());
//   const [recipientEmail, setRecipientEmail] = useState("");

//   // ✅ Keys to hide from the table
//   const hiddenKeys = ["id", "tech_color"];

//   const getHeaderLabel = (key) => {
//     const labels = {
//       room_number: "Room Number",
//       title: "Title",
//       status: "Status",
//       reported: "Reported",
//       staff_name: "Staff Name",
//       finish_time: "Finish Time",
//       appt_start: "Appt Start",
//       scheduled_end: "Scheduled End",
//       assigned_technician: "Assigned Technician",
//       closed_by_admin: "Close by", 
//     };
//     return labels[key] || key;
//   };

//   const displayData = async () => {
//     setLoading(true);
//     let start = selectedDate.startOf(periodType === "month" ? 'month' : 'isoWeek').format("YYYY-MM-DD");
//     let end = selectedDate.endOf(periodType === "month" ? 'month' : 'isoWeek').format("YYYY-MM-DD");

//     try {
//       const response = await axiosClient.get("api/issue-list-data/", { params: { start, end } });
//       setTableData(response.data);
//     } catch (err) {
//       console.error("Data fetch failed", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <Box sx={{ p: 3 }}>
//         <Typography variant="h5" align="center" gutterBottom sx={{ mb: 4, fontWeight: 'bold' }}>
//           {t("smsReport.title")}
//         </Typography>

//         <Paper elevation={4} sx={{ p: 3, mb: 4 }}>
//           <Grid container spacing={3}>
//             <Grid item xs={12} sm={4}>
//               <FormControl fullWidth>
//                 <InputLabel>{t("smsReport.periodType")}</InputLabel>
//                 <Select value={periodType} onChange={(e) => setPeriodType(e.target.value)} label={t("smsReport.periodType")}>
//                   <MenuItem value="month">{t("smsReport.periodMonth")}</MenuItem>
//                   <MenuItem value="week">{t("smsReport.periodWeek")}</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <DatePicker
//                 label={periodType === "month" ? t("smsReport.selectMonth") : t("smsReport.selectWeek")}
//                 value={selectedDate}
//                 onChange={(newValue) => setSelectedDate(newValue)}
//                 slotProps={{ textField: { fullWidth: true } }}
//               />
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <TextField fullWidth label={t("smsReport.recipientEmail")} value={recipientEmail} onChange={(e) => setRecipientEmail(e.target.value)} />
//             </Grid>
//             <Grid item xs={12} sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
//               <Button variant="contained" onClick={displayData} disabled={loading}>PRESENT DATA</Button>
//               <Button variant="outlined" onClick={() => setTableData([])}>Clear</Button>
//             </Grid>
//           </Grid>
//         </Paper>

//         <Card elevation={8}>
//           <CardContent>
//             {loading ? (
//               <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}><CircularProgress /></Box>
//             ) : tableData.length > 0 ? (
//               <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
//                 <Table stickyHeader>
//                   <TableHead>
//                     <TableRow>
//                       {/* ✅ Filter out ID and Tech Color keys from Header */}
//                       {Object.keys(tableData[0])
//                         .filter(key => !hiddenKeys.includes(key))
//                         .map((key) => (
//                         <TableCell key={key} sx={{ fontWeight: 'bold', bgcolor: 'background.default', whiteSpace: 'nowrap' }}>
//                           {getHeaderLabel(key)}
//                         </TableCell>
//                       ))}
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {tableData.map((row, index) => (
//                       <TableRow key={index} hover>
//                         {/* ✅ Filter out ID and Tech Color keys from Data rows */}
//                         {Object.entries(row)
//                           .filter(([key]) => !hiddenKeys.includes(key))
//                           .map(([key, val], i) => {
                          
//                           if (key === "closed_by_admin") {
//                             const rawValue = val ? String(val).toUpperCase() : "";
//                             if (rawValue.includes("ADMIN") || rawValue.includes("RECEPTION")) {
//                               return <TableCell key={i}>{val}</TableCell>;
//                             } else {
//                               return <TableCell key={i} align="center" sx={{ color: 'red', fontWeight: 'bold', fontSize: '1.2rem' }}>X</TableCell>;
//                             }
//                           }

//                           return <TableCell key={i}>{val}</TableCell>;
//                         })}
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             ) : (
//                <Typography align="center" sx={{ py: 4 }}>No data found.</Typography>
//             )}
//           </CardContent>
//         </Card>
//       </Box>
//     </LocalizationProvider>
//   );
// }

// export default SendEmailSMS;



////////////////////////////////////////////////////////////////////////////////////////////

// import { useState } from "react";
// import {
//   Box, Button, CardContent, Table, TableCell, TableContainer,
//   TableHead, TableRow, TextField, MenuItem, Select, InputLabel,
//   FormControl, Grid, Card, Paper, TableBody, Typography, CircularProgress
// } from "@mui/material";
// import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import axiosClient from "../axiosClient";
// import dayjs from "dayjs";
// import isoWeek from "dayjs/plugin/isoWeek";
// import { useTranslation } from "react-i18next";

// dayjs.extend(isoWeek);





// function SendEmailSMS() {
//   const { t } = useTranslation();
//   const [loading, setLoading] = useState(false);
//   const [tableData, setTableData] = useState([]); 
//   const [periodType, setPeriodType] = useState("month");
//   const [selectedDate, setSelectedDate] = useState(dayjs());
//   const [recipientEmail, setRecipientEmail] = useState("");

//   // ✅ Keys to hide from the table
//   const hiddenKeys = ["id", "tech_color"];

//   const getHeaderLabel = (key) => {
//     const labels = {
//       room_number: "Room Number",
//       title: "Title",
//       status: "Status",
//       reported: "Reported",
//       staff_name: "Staff Name",
//       finish_time: "Finish Time",
//       appt_start: "Appt Start",
//       scheduled_end: "Scheduled End",
//       assigned_technician: "Assigned Technician",
//       closed_by_admin: "Close by", 
//     };
//     return labels[key] || key;
//   };

//   const displayData = async () => {
//     setLoading(true);
//     let start = selectedDate.startOf(periodType === "month" ? 'month' : 'isoWeek').format("YYYY-MM-DD");
//     let end = selectedDate.endOf(periodType === "month" ? 'month' : 'isoWeek').format("YYYY-MM-DD");

//     try {
//       // const response = await axiosClient.get("api/issue-list-data/", { params: { start, end } });
//       const response = await axiosClient.get("issue-list-data/", { params: { start, end } });
//       setTableData(response.data);
//     } catch (err) {
//       console.error("Data fetch failed", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <Box sx={{ p: 3 }}>
//         <Typography variant="h5" align="center" gutterBottom sx={{ mb: 4, fontWeight: 'bold' }}>
//           {t("ISSUES REPORT.title")}
//         </Typography>

//         <Paper elevation={4} sx={{ p: 3, mb: 4 }}>
//           <Grid container spacing={3}>
//             <Grid item xs={12} sm={4}>
//               <FormControl fullWidth>
//                 <InputLabel>{t("smsReport.periodType")}</InputLabel>
//                 <Select value={periodType} onChange={(e) => setPeriodType(e.target.value)} label={t("smsReport.periodType")}>
//                   <MenuItem value="month">{t("smsReport.periodMonth")}</MenuItem>
//                   <MenuItem value="week">{t("smsReport.periodWeek")}</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid item xs={12} sm={4}>
//               <DatePicker
//                 label={periodType === "month" ? t("smsReport.selectMonth") : t("smsReport.selectWeek")}
//                 value={selectedDate}
//                 onChange={(newValue) => setSelectedDate(newValue)}
//                 slotProps={{ textField: { fullWidth: true } }}
//               />
//             </Grid>
//             {/* <Grid item xs={12} sm={4}>
//               <TextField fullWidth label={t("smsReport.recipientEmail")} value={recipientEmail} onChange={(e) => setRecipientEmail(e.target.value)} />
//             </Grid> */}
//             <Grid item xs={12} sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
//               <Button variant="contained" onClick={displayData} disabled={loading}>PRESENT DATA</Button>
//               <Button variant="outlined" onClick={() => setTableData([])}>Clear</Button>
//             </Grid>
//           </Grid>
//         </Paper>

//         <Card elevation={8}>
//           <CardContent>
//             {loading ? (
//               <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}><CircularProgress /></Box>
//             ) : tableData.length > 0 ? (
//               <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
//                 <Table stickyHeader>
//                   <TableHead>
//                     <TableRow>
//                       {/* ✅ Filter out ID and Tech Color keys from Header */}
//                       {Object.keys(tableData[0])
//                         .filter(key => !hiddenKeys.includes(key))
//                         .map((key) => (
//                         <TableCell key={key} sx={{ fontWeight: 'bold', bgcolor: 'background.default', whiteSpace: 'nowrap' }}>
//                           {getHeaderLabel(key)}
//                         </TableCell>
//                       ))}
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {tableData.map((row, index) => (
//                       <TableRow key={index} hover>
//                         {/* ✅ Filter out ID and Tech Color keys from Data rows */}
//                         {Object.entries(row)
//                           .filter(([key]) => !hiddenKeys.includes(key))
//                           .map(([key, val], i) => {
                          
//                           if (key === "closed_by_admin") {
//                             const rawValue = val ? String(val).toUpperCase() : "";
//                             if (rawValue.includes("ADMIN") || rawValue.includes("RECEPTION")) {
//                               return <TableCell key={i}>{val}</TableCell>;
//                             } else {
//                               return <TableCell key={i} align="center" sx={{ color: 'red', fontWeight: 'bold', fontSize: '1.2rem' }}>X</TableCell>;
                              
//                             }
//                           }

//                           return <TableCell key={i}>{val}</TableCell>;
//                         })}
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             ) : (
//                <Typography align="center" sx={{ py: 4 }}>No data found.</Typography>
//             )}
//           </CardContent>
//         </Card>
//       </Box>
//     </LocalizationProvider>
//   );
// }

// export default SendEmailSMS;

/////////////////////////////////////////////////////////////////////////////////

// import React, { useState } from "react";
// import {
//   Box, Button, CardContent, Table, TableCell, TableContainer,
//   TableHead, TableRow, Grid, Card, Paper, TableBody, Typography, CircularProgress
// } from "@mui/material";
// import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import axiosClient from "../axiosClient";
// import dayjs from "dayjs";
// import { useTranslation } from "react-i18next";

// function SendEmailSMS() {
//   const { t } = useTranslation();
//   const [loading, setLoading] = useState(false);
//   const [tableData, setTableData] = useState([]);
//   const [selectedDate, setSelectedDate] = useState(dayjs());

//   // ✅ Keys to hide from the table
//   const hiddenKeys = ["id", "tech_color"];

//   const getHeaderLabel = (key) => {
//     const labels = {
//       room_number: t("Room Number") || "Room Number",
//       title: t("Title") || "Title",
//       status: t("Status") || "Status",
//       reported: t("Reported") || "Reported",
//       staff_name: t("Staff Name") || "Staff Name",
//       finish_time: t("Finish Time") || "Finish Time",
//       appt_start: t("Appt Start") || "Appt Start",
//       scheduled_end: t("Scheduled End") || "Scheduled End",
//       assigned_technician: t("Assigned Technician") || "Assigned Technician",
//       closed_by_admin: t("Close by") || "Close by",
//     };
//     return labels[key] || key;
//   };

//   const displayData = async () => {
//     setLoading(true);
//     // ✅ Always calculate start and end of the selected month
//     let start = selectedDate.startOf('month').format("YYYY-MM-DD");
//     let end = selectedDate.endOf('month').format("YYYY-MM-DD");

//     try {
//       const response = await axiosClient.get("issue-list-data/", { params: { start, end } });
//       setTableData(response.data);
//     } catch (err) {
//       console.error("Data fetch failed", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <Box sx={{ p: 3 }}>
//         {/* ✅ Title updated to ISSUES REPORT */}
//         <Typography variant="h5" align="center" gutterBottom sx={{ mb: 4, fontWeight: 'bold' }}>
//           ISSUES REPORT
//         </Typography>

//          {/* <Paper elevation={4} sx={{ p: 3, mb: 4 }}>
//           <Grid container spacing={3} justifyContent="center">
//             <Grid item xs={12} sm={6}>
//                             <DatePicker
//                 label={t("smsReport.selectMonth")}
//                 value={selectedDate}
//                 onChange={(newValue) => setSelectedDate(newValue)}
//                 views={['year', 'month']}
//                 slotProps={{ textField: { fullWidth: true } }}
//               />
//             </Grid> 
            
//             <Grid item xs={12} sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
//               <Button variant="contained" onClick={displayData} disabled={loading}>
//                 PRESENT DATA
//               </Button>
//               <Button variant="outlined" onClick={() => setTableData([])}>
//                 {t("Clear") || "Clear"}
//               </Button>
//             </Grid>
//           </Grid>
//         </Paper> */}



// <Paper elevation={4} sx={{ p: 2, mb: 4 }}>
//           <Box 
//             sx={{ 
//               display: 'flex', 
//               flexDirection: 'row', 
//               alignItems: 'center', 
//               justifyContent: 'center',
//               gap: 2 // This creates the exact spacing between items
//             }}
//           >
//             {/* 1. Month Picker */}
//             <Box sx={{ width: '250px' }}>
//               <DatePicker
//                 label={t("smsReport.selectMonth")}
//                 value={selectedDate}
//                 onChange={(newValue) => setSelectedDate(newValue)}
//                 views={['year', 'month']}
//                 slotProps={{ 
//                   textField: { 
//                     fullWidth: true, 
//                     size: "small" 
//                   } 
//                 }}
//               />
//             </Box>

//             {/* 2. Present Data Button */}
//             <Button 
//               variant="contained" 
//               onClick={displayData} 
//               disabled={loading}
//               sx={{ 
//                 height: '40px', 
//                 whiteSpace: 'nowrap', 
//                 fontWeight: 'bold',
//                 px: 3 
//               }}
//             >
//               {loading ? <CircularProgress size={24} /> : "PRESENT DATA"}
//             </Button>

//             {/* 3. Clear Link Button */}
//             <Button 
//               variant="text" 
//               onClick={() => setTableData([])}
//               sx={{ 
//                 height: '40px', 
//                 color: 'gray',
//                 textTransform: 'none',
//                 minWidth: 'auto'
//               }}
//             >
//               Clear
//             </Button>
//           </Box>
//         </Paper>


//         <Card elevation={8}>
//           <CardContent>
//             {loading ? (
//               <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}>
//                 <CircularProgress />
//               </Box>
//             ) : tableData.length > 0 ? (
//               <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
//                 <Table stickyHeader>
//                   <TableHead>
//                     <TableRow>
//                       {Object.keys(tableData[0])
//                         .filter(key => !hiddenKeys.includes(key))
//                         .map((key) => (
//                           <TableCell key={key} sx={{ fontWeight: 'bold', bgcolor: 'background.default', whiteSpace: 'nowrap' }}>
//                             {getHeaderLabel(key)}
//                           </TableCell>
//                         ))}
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {tableData.map((row, index) => (
//                       <TableRow key={index} hover>
//                         {Object.entries(row)
//                           .filter(([key]) => !hiddenKeys.includes(key))
//                           .map(([key, val], i) => {
                            
//                             if (key === "closed_by_admin") {
//                               const rawValue = val ? String(val).toUpperCase() : "";
//                               // Logic to show Name if Admin/Reception, otherwise a red X
//                               if (rawValue.includes("ADMIN") || rawValue.includes("RECEPTION")) {
//                                 return <TableCell key={i}>{val}</TableCell>;
//                               } else {
//                                 return (
//                                   <TableCell key={i} align="center" sx={{ color: 'red', fontWeight: 'bold', fontSize: '1.2rem' }}>
//                                     X
//                                   </TableCell>
//                                 );
//                               }
//                             }

//                             return <TableCell key={i}>{val || "-"}</TableCell>;
//                           })}
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             ) : (
//               <Typography align="center" sx={{ py: 4 }}>
//                 {t("No data found.") || "No data found."}
//               </Typography>
//             )}
//           </CardContent>
//         </Card>
//       </Box>
//     </LocalizationProvider>
//   );
// }

// export default SendEmailSMS;


/////////////////////////////////////////////////////////////

// import React, { useState } from "react";
// import {
//   Box, Button, CardContent, Table, TableCell, TableContainer,
//   TableHead, TableRow, Grid, Card, Paper, TableBody, Typography, 
//   CircularProgress, Stack, FormControl, InputLabel, Select, MenuItem, TextField
// } from "@mui/material";
// import { LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import axiosClient from "../axiosClient";
// import dayjs from "dayjs";
// import { useTranslation } from "react-i18next";

// function SendEmailSMS() {
//   const { t } = useTranslation();
  
//   // 1. Separate States for Day, Month, and Year
//   const [loading, setLoading] = useState(false);
//   const [tableData, setTableData] = useState([]);
//   const [day, setDay] = useState(dayjs().date());
//   const [month, setMonth] = useState(dayjs().month() + 1); // 1-12
//   const [year, setYear] = useState(dayjs().year());

//   const hiddenKeys = ["id", "tech_color"];

//   const getHeaderLabel = (key) => {
//     const labels = {
//       room_number: t("Room Number") || "Room Number",
//       title: t("Title") || "Title",
//       status: t("Status") || "Status",
//       reported: t("Reported") || "Reported",
//       staff_name: t("Staff Name") || "Staff Name",
//       finish_time: t("Finish Time") || "Finish Time",
//       appt_start: t("Appt Start") || "Appt Start",
//       scheduled_end: t("Scheduled End") || "Scheduled End",
//       assigned_technician: t("Assigned Technician") || "Assigned Technician",
//       closed_by_admin: t("Close by") || "Close by",
//     };
//     return labels[key] || key;
//   };

//   const displayData = async () => {
//     setLoading(true);
    
//     // Construct the date string from the 3 separate inputs
//     // We use padding to ensure format YYYY-MM-DD
//     const dateString = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    
//     try {
//       const response = await axiosClient.get("issue-list-data/", { 
//         params: { start: dateString, end: dateString } 
//       });
//       setTableData(response.data);
//     } catch (err) {
//       console.error("Data fetch failed", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <Box sx={{ p: 3 }}>
//         <Typography variant="h5" align="center" gutterBottom sx={{ mb: 4, fontWeight: 'bold' }}>
//           ISSUES REPORT
//         </Typography>

//         <Paper elevation={4} sx={{ p: 2, mb: 4 }}>
//           {/* ✅ STACK forces everything onto ONE horizontal line */}
//           <Stack 
//             direction="row" 
//             spacing={10} 
//             alignItems="center" 
//             justifyContent="center"
//             sx={{ flexWrap: 'nowrap' }}
//           >
            
//             {/* --- 1. DAY BOX --- */}
//             <FormControl size="small" sx={{ minWidth: 80 }}>
//               <InputLabel>Day</InputLabel>
//               <Select value={day} label="Day" onChange={(e) => setDay(e.target.value)}>
//                 {[...Array(31)].map((_, i) => (
//                   <MenuItem key={i + 1} value={i + 1}>{i + 1}</MenuItem>
//                 ))}
//               </Select>
//             </FormControl>

//             {/* --- 2. MONTH BOX --- */}
//             <FormControl size="small" sx={{ minWidth: 100 }}>
//               <InputLabel>Month</InputLabel>
//               <Select value={month} label="Month" onChange={(e) => setMonth(e.target.value)}>
//                 {["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"].map((m, i) => (
//                   <MenuItem key={i + 1} value={i + 1}>{m}</MenuItem>
//                 ))}
//               </Select>
//             </FormControl>

//             {/* --- 3. YEAR BOX --- */}
//             <TextField
//               label="Year"
//               type="number"
//               size="small"
//               sx={{ width: 100 }}
//               value={year}
//               onChange={(e) => setYear(e.target.value)}
//             />

//             {/* --- 4. PRESENT DATA BUTTON --- */}
//             <Button 
//               variant="contained" 
//               onClick={displayData} 
//               disabled={loading}
//               sx={{ 
//                 height: '40px', 
//                 whiteSpace: 'nowrap', 
//                 fontWeight: 'bold',
//                 px: 3 
//               }}
//             >
//               {loading ? <CircularProgress size={24} color="inherit" /> : "PRESENT DATA"}
//             </Button>

//             {/* --- 5. CLEAR LINK --- */}
//             <Button 
//               variant="text" 
//               onClick={() => setTableData([])}
//               sx={{ 
//                 height: '40px', 
//                 color: 'gray',
//                 textTransform: 'none',
//                 minWidth: 'auto'
//               }}
//             >
//               Clear
//             </Button>
//           </Stack>
//         </Paper>

//         <Card elevation={8}>
//           <CardContent>
//             {loading ? (
//               <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}>
//                 <CircularProgress />
//               </Box>
//             ) : tableData.length > 0 ? (
//               <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
//                 <Table stickyHeader>
//                   <TableHead>
//                     <TableRow>
//                       {Object.keys(tableData[0])
//                         .filter(key => !hiddenKeys.includes(key))
//                         .map((key) => (
//                           <TableCell key={key} sx={{ fontWeight: 'bold', bgcolor: 'background.default', whiteSpace: 'nowrap' }}>
//                             {getHeaderLabel(key)}
//                           </TableCell>
//                         ))}
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {tableData.map((row, index) => (
//                       <TableRow key={index} hover>
//                         {Object.entries(row)
//                           .filter(([key]) => !hiddenKeys.includes(key))
//                           .map(([key, val], i) => {
//                             if (key === "closed_by_admin") {
//                               const rawValue = val ? String(val).toUpperCase() : "";
//                               if (rawValue.includes("ADMIN") || rawValue.includes("RECEPTION")) {
//                                 return <TableCell key={i}>{val}</TableCell>;
//                               } else {
//                                 return (
//                                   <TableCell key={i} align="center" sx={{ color: 'red', fontWeight: 'bold', fontSize: '1.2rem' }}>
//                                     X
//                                   </TableCell>
//                                 );
//                               }
//                             }
//                             return <TableCell key={i}>{val || "-"}</TableCell>;
//                           })}
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             ) : (
//               <Typography align="center" sx={{ py: 4 }}>
//                 {t("No data found.") || "No data found."}
//               </Typography>
//             )}
//           </CardContent>
//         </Card>
//       </Box>
//     </LocalizationProvider>
//   );
// }

// export default SendEmailSMS;




// import React, { useState } from "react";
// import {
//   Box, Button, CardContent, Table, TableCell, TableContainer,
//   TableHead, TableRow, Grid, Card, Paper, TableBody, Typography, 
//   CircularProgress, Stack, FormControl, InputLabel, Select, MenuItem, TextField
// } from "@mui/material";
// import { LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import axiosClient from "../axiosClient";
// import dayjs from "dayjs";
// import { useTranslation } from "react-i18next";

// function SendEmailSMS() {
//   const { t } = useTranslation();
  
//   // States
//   const [loading, setLoading] = useState(false);
//   const [tableData, setTableData] = useState([]);
//   const [day, setDay] = useState("");
//   const [month, setMonth] = useState("");
//   const [year, setYear] = useState(dayjs().year());

//   const hiddenKeys = ["id", "tech_color"];

//   const getHeaderLabel = (key) => {
//     const labels = {
//       room_number: t("Room Number") || "Room Number",
//       title: t("Title") || "Title",
//       status: t("Status") || "Status",
//       reported: t("Reported") || "Reported",
//       staff_name: t("Staff Name") || "Staff Name",
//       finish_time: t("Finish Time") || "Finish Time",
//       appt_start: t("Appt Start") || "Appt Start",
//       scheduled_end: t("Scheduled End") || "Scheduled End",
//       assigned_technician: t("Assigned Technician") || "Assigned Technician",
//       closed_by_admin: t("Close by") || "Close by",
//     };
//     return labels[key] || key;
//   };

//   // Logic to determine if we fetch by Day, Month, or Year
//   const displayData = async () => {
//     setLoading(true);
//     let params = {};

//     if (day && month) {
//       // 1. DAY MODE: Fetch specific date
//       const dateStr = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
//       params = { start: dateStr, end: dateStr };
//     } else if (month) {
//       // 2. MONTH MODE: Fetch full month
//       const startOfMonth = dayjs(`${year}-${month}-01`).startOf('month').format("YYYY-MM-DD");
//       const endOfMonth = dayjs(`${year}-${month}-01`).endOf('month').format("YYYY-MM-DD");
//       params = { start: startOfMonth, end: endOfMonth };
//     } else {
//       // 3. YEAR MODE: Fetch full year
//       params = { 
//         start: `${year}-01-01`, 
//         end: `${year}-12-31` 
//       };
//     }

//     try {
//       const response = await axiosClient.get("issue-list-data/", { params });
//       setTableData(response.data);
//     } catch (err) {
//       console.error("Data fetch failed", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Selection Handlers to ensure "One Mode at a time"
//   const handleYearChange = (val) => {
//     setYear(val);
//     setMonth(""); // Reset others
//     setDay("");
//   };

//   const handleMonthChange = (val) => {
//     setMonth(val);
//     setDay(""); // Reset day to search full month
//   };

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <Box sx={{ p: 3 }}>
//         <Typography variant="h5" align="center" gutterBottom sx={{ mb: 4, fontWeight: 'bold' }}>
//           ISSUES REPORT
//         </Typography>

//         <Paper elevation={4} sx={{ p: 3, mb: 4 }}>
//           {/* ✅ spacing={6} adds the wide gap between the boxes */}
//           <Stack 
//             direction="row" 
//             spacing={6} 
//             alignItems="center" 
//             justifyContent="center"
//           >
            
//             {/* --- 1. YEAR BOX (Base Filter) --- */}
//             <TextField
//               label="Select Year"
//               type="number"
//               size="small"
//               sx={{ width: 120 }}
//               value={year}
//               onChange={(e) => handleYearChange(e.target.value)}
//             />

//             {/* --- 2. MONTH BOX (Refines Year) --- */}
//             <FormControl size="small" sx={{ minWidth: 140 }}>
//               <InputLabel>Select Month</InputLabel>
//               <Select 
//                 value={month} 
//                 label="Select Month" 
//                 onChange={(e) => handleMonthChange(e.target.value)}
//               >
//                 <MenuItem value="">-- Full Year --</MenuItem>
//                 {["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"].map((m, i) => (
//                   <MenuItem key={i + 1} value={i + 1}>{m}</MenuItem>
//                 ))}
//               </Select>
//             </FormControl>

//             {/* --- 3. DAY BOX (Refines Month) --- */}
//             <FormControl size="small" sx={{ minWidth: 120 }} disabled={!month}>
//               <InputLabel>Select Day</InputLabel>
//               <Select 
//                 value={day} 
//                 label="Select Day" 
//                 onChange={(e) => setDay(e.target.value)}
//               >
//                 <MenuItem value="">-- Full Month --</MenuItem>
//                 {[...Array(31)].map((_, i) => (
//                   <MenuItem key={i + 1} value={i + 1}>{i + 1}</MenuItem>
//                 ))}
//               </Select>
//             </FormControl>

//             {/* --- 4. PRESENT DATA BUTTON --- */}
//             <Button 
//               variant="contained" 
//               onClick={displayData} 
//               disabled={loading}
//               sx={{ height: 40, px: 4, fontWeight: 'bold', whiteSpace: 'nowrap' }}
//             >
//               {loading ? <CircularProgress size={24} color="inherit" /> : "PRESENT DATA"}
//             </Button>

//             {/* --- 5. CLEAR BUTTON --- */}
//             <Button 
//               variant="text" 
//               onClick={() => { setDay(""); setMonth(""); setTableData([]); }}
//               sx={{ height: 40, color: 'gray', textTransform: 'none' }}
//             >
//               Clear
//             </Button>
//           </Stack>
//         </Paper>

//         <Card elevation={8}>
//           <CardContent>
//             {loading ? (
//               <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}>
//                 <CircularProgress />
//               </Box>
//             ) : tableData.length > 0 ? (
//               <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
//                 <Table stickyHeader>
//                   <TableHead>
//                     <TableRow>
//                       {Object.keys(tableData[0])
//                         .filter(key => !hiddenKeys.includes(key))
//                         .map((key) => (
//                           <TableCell key={key} sx={{ fontWeight: 'bold', bgcolor: 'background.default', whiteSpace: 'nowrap' }}>
//                             {getHeaderLabel(key)}
//                           </TableCell>
//                         ))}
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {tableData.map((row, index) => (
//                       <TableRow key={index} hover>
//                         {Object.entries(row)
//                           .filter(([key]) => !hiddenKeys.includes(key))
//                           .map(([key, val], i) => {
//                             if (key === "closed_by_admin") {
//                               const rawValue = val ? String(val).toUpperCase() : "";
//                               if (rawValue.includes("ADMIN") || rawValue.includes("RECEPTION")) {
//                                 return <TableCell key={i}>{val}</TableCell>;
//                               } else {
//                                 return (
//                                   <TableCell key={i} align="center" sx={{ color: 'red', fontWeight: 'bold', fontSize: '1.2rem' }}>
//                                     X
//                                   </TableCell>
//                                 );
//                               }
//                             }
//                             return <TableCell key={i}>{val || "-"}</TableCell>;
//                           })}
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             ) : (
//               <Typography align="center" sx={{ py: 4 }}>
//                 {t("No data found.") || "No data found."}
//               </Typography>
//             )}
//           </CardContent>
//         </Card>
//       </Box>
//     </LocalizationProvider>
//   );
// }

// export default SendEmailSMS;

// import React, { useState } from "react";
// import {
//   Box, Button, CardContent, Table, TableCell, TableContainer,
//   TableHead, TableRow, Card, Paper, TableBody, Typography, 
//   CircularProgress, Stack, FormControl, InputLabel, Select, MenuItem, TextField
// } from "@mui/material";
// import { LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import axiosClient from "../axiosClient";
// import dayjs from "dayjs";
// import { useTranslation } from "react-i18next";

// function SendEmailSMS() {
//   const { t } = useTranslation();
  
//   // States
//   const [loading, setLoading] = useState(false);
//   const [tableData, setTableData] = useState([]);
//   const [day, setDay] = useState("");
//   const [month, setMonth] = useState("");
//   const [year, setYear] = useState(dayjs().year());

//   const hiddenKeys = ["id", "tech_color"];

//   const getHeaderLabel = (key) => {
//     const labels = {
//       room_number: "Room Number",
//       title: "Title",
//       status: "Status",
//       reported: "Reported",
//       staff_name: "Staff Name",
//       finish_time: "Finish Time",
//       closed_by_admin: "Close by",
//     };
//     return labels[key] || key;
//   };

//   // ✅ CORRECTED FILTER LOGIC
//   const displayData = async () => {
//     setLoading(true);
//     let start, end;

//     const yearNum = parseInt(year);
//     const monthNum = parseInt(month);
//     const dayNum = parseInt(day);

//     if (day && month) {
//       // 1. SPECIFIC DAY MODE
//       // Reset to date(1) first to prevent month-end overflow bugs
//       const dateObj = dayjs().year(yearNum).month(monthNum - 1).date(1).date(dayNum);
//       const dateStr = dateObj.format("YYYY-MM-DD");
//       start = dateStr;
//       end = dateStr;
//     } else if (month) {
//       // 2. FULL MONTH MODE
//       const dateObj = dayjs().year(yearNum).month(monthNum - 1).date(1);
//       start = dateObj.startOf('month').format("YYYY-MM-DD");
//       end = dateObj.endOf('month').format("YYYY-MM-DD");
//     } else {
//       // 3. FULL YEAR MODE
//       start = `${yearNum}-01-01`;
//       end = `${yearNum}-12-31`;
//     }

//     console.log("Requesting Range:", start, "to", end);

//     try {
//       const response = await axiosClient.get("issue-list-data/", { 
//         params: { start, end } 
//       });
//       setTableData(response.data);
//     } catch (err) {
//       console.error("Fetch failed", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <Box sx={{ p: 3 }}>
//         <Typography variant="h5" align="center" gutterBottom sx={{ mb: 4, fontWeight: 'bold' }}>
//           ISSUES REPORT
//         </Typography>

//         <Paper elevation={4} sx={{ p: 3, mb: 4 }}>
//           <Stack 
//             direction="row" 
//             spacing={6} 
//             alignItems="center" 
//             justifyContent="center"
//           >
//             {/* YEAR BOX */}
//             <TextField
//               label="Year"
//               type="number"
//               size="small"
//               sx={{ width: 100 }}
//               value={year}
//               onChange={(e) => {
//                 setYear(e.target.value);
//                 setMonth(""); 
//                 setDay("");
//               }}
//             />

//             {/* MONTH BOX */}
//             <FormControl size="small" sx={{ minWidth: 120 }}>
//               <InputLabel>Month</InputLabel>
//               <Select 
//                 value={month} 
//                 label="Month" 
//                 onChange={(e) => {
//                   setMonth(e.target.value);
//                   setDay(""); 
//                 }}
//               >
//                 <MenuItem value="">-- None --</MenuItem>
//                 {["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"].map((m, i) => (
//                   <MenuItem key={i + 1} value={i + 1}>{m}</MenuItem>
//                 ))}
//               </Select>
//             </FormControl>

//             {/* DAY BOX */}
//             <FormControl size="small" sx={{ minWidth: 100 }} disabled={!month}>
//               <InputLabel>Day</InputLabel>
//               <Select 
//                 value={day} 
//                 label="Day" 
//                 onChange={(e) => setDay(e.target.value)}
//               >
//                 <MenuItem value="">-- None --</MenuItem>
//                 {[...Array(31)].map((_, i) => (
//                   <MenuItem key={i + 1} value={i + 1}>{i + 1}</MenuItem>
//                 ))}
//               </Select>
//             </FormControl>

//             <Button 
//               variant="contained" 
//               onClick={displayData} 
//               disabled={loading}
//               sx={{ height: 40, px: 4, fontWeight: 'bold' }}
//             >
//               {loading ? <CircularProgress size={24} color="inherit" /> : "PRESENT DATA"}
//             </Button>

//             <Button 
//               variant="text" 
//               onClick={() => { setDay(""); setMonth(""); setTableData([]); }}
//               sx={{ height: 40, color: 'gray', textTransform: 'none' }}
//             >
//               Clear
//             </Button>
//           </Stack>
//         </Paper>

//         <Card elevation={8}>
//           <CardContent>
//             {loading ? (
//               <Box sx={{ display: "flex", justifyContent: "center", p: 5 }}>
//                 <CircularProgress />
//               </Box>
//             ) : tableData.length > 0 ? (
//               <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
//                 <Table stickyHeader>
//                   <TableHead>
//                     <TableRow>
//                       {Object.keys(tableData[0])
//                         .filter(key => !hiddenKeys.includes(key))
//                         .map((key) => (
//                           <TableCell key={key} sx={{ fontWeight: 'bold', bgcolor: 'background.default' }}>
//                             {getHeaderLabel(key)}
//                           </TableCell>
//                         ))}
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {tableData.map((row, index) => (
//                       <TableRow key={index} hover>
//                         {Object.entries(row)
//                           .filter(([key]) => !hiddenKeys.includes(key))
//                           .map(([key, val], i) => {
//                             // ✅ Fix for "Close by" Admin column
//                             if (key === "closed_by_admin") {
//                                 const rawValue = val ? String(val).toUpperCase() : "";
//                                 if (rawValue.includes("ADMIN") || rawValue.includes("RECEPTION")) {
//                                   return <TableCell key={i}>{val}</TableCell>;
//                                 } else {
//                                   return (
//                                     <TableCell key={i} align="center" sx={{ color: 'red', fontWeight: 'bold', fontSize: '1.2rem' }}>
//                                       X
//                                     </TableCell>
//                                   );
//                                 }
//                             }
//                             return <TableCell key={i}>{val || "-"}</TableCell>;
//                           })}
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             ) : (
//               <Typography align="center" sx={{ py: 4 }}>No data found.</Typography>
//             )}
//           </CardContent>
//         </Card>
//       </Box>
//     </LocalizationProvider>
//   );
// }

// export default SendEmailSMS;

// import React, { useState } from "react";
// import {
//   Box, Button, CardContent, Table, TableCell, TableContainer,
//   TableHead, TableRow, Card, Paper, TableBody, Typography, 
//   CircularProgress, Stack, FormControl, InputLabel, Select, MenuItem, TextField
// } from "@mui/material";
// import { LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import axiosClient from "../axiosClient";
// import dayjs from "dayjs";
// import { useTranslation } from "react-i18next";

// // ✅ Helper defined outside the component
// const pad = (n) => String(n).padStart(2, '0');

// function SendEmailSMS() {
//   const { t } = useTranslation();
  
//   const [loading, setLoading] = useState(false);
//   const [tableData, setTableData] = useState([]);
//   const [day, setDay] = useState("");
//   const [month, setMonth] = useState("");
//   const [year, setYear] = useState(dayjs().year());

//   const hiddenKeys = ["id", "tech_color"];

//   const getHeaderLabel = (key) => {
//     const labels = {
//       room_number: "Room Number",
//       title: "Title",
//       status: "Status",
//       reported: "Reported",
//       staff_name: "Staff Name",
//       finish_time: "Finish Time",
//       closed_by_admin: "Close by",
//     };
//     return labels[key] || key;
//   };

//   const displayData = async () => {
//     setLoading(true);
//     let start, end;

//     if (day && month) {
//       // 1. Specific Day
//       const dateStr = `${year}-${pad(month)}-${pad(day)}`;
//       start = dateStr;
//       end = dateStr;
//     } else if (month) {
//       // 2. Full Month
//       start = `${year}-${pad(month)}-01`;
//       end = dayjs(start).endOf('month').format("YYYY-MM-DD");
//     } else {
//       // 3. Full Year
//       start = `${year}-01-01`;
//       end = `${year}-12-31`;
//     }

//     try {
//       const response = await axiosClient.get("issue-list-data/", { 
//         params: { start, end } 
//       });
//       setTableData(Array.isArray(response.data) ? response.data : []);
//     } catch (err) {
//       console.error("Fetch failed", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <Box sx={{ p: 3 }}>
//         <Typography variant="h5" align="center" gutterBottom sx={{ mb: 4, fontWeight: 'bold' }}>
//           ISSUES REPORT
//         </Typography>

//         <Paper elevation={4} sx={{ p: 3, mb: 4 }}>
//           <Stack direction="row" spacing={6} alignItems="center" justifyContent="center">
            
//             <TextField
//               label="Year"
//               type="number"
//               size="small"
//               sx={{ width: 110 }}
//               value={year}
//               onChange={(e) => {
//                 setYear(e.target.value);
//                 setMonth("");
//                 setDay("");
//               }}
//             />

//             <FormControl size="small" sx={{ minWidth: 130 }}>
//               <InputLabel>Month</InputLabel>
//               <Select 
//                 value={month} 
//                 label="Month" 
//                 onChange={(e) => {
//                   setMonth(e.target.value);
//                   setDay("");
//                 }}
//               >
//                 <MenuItem value="">-- Full Year --</MenuItem>
//                 <MenuItem value="01">January</MenuItem>
//                 <MenuItem value="02">February</MenuItem>
//                 <MenuItem value="03">March</MenuItem>
//                 <MenuItem value="04">April</MenuItem>
//                 <MenuItem value="05">May</MenuItem>
//                 <MenuItem value="06">June</MenuItem>
//                 <MenuItem value="07">July</MenuItem>
//                 <MenuItem value="08">August</MenuItem>
//                 <MenuItem value="09">September</MenuItem>
//                 <MenuItem value="10">October</MenuItem>
//                 <MenuItem value="11">November</MenuItem>
//                 <MenuItem value="12">December</MenuItem>
//               </Select>
//             </FormControl>

//             <FormControl size="small" sx={{ minWidth: 110 }} disabled={!month}>
//               <InputLabel>Day</InputLabel>
//               <Select 
//                 value={day} 
//                 label="Day" 
//                 onChange={(e) => setDay(e.target.value)}
//               >
//                 <MenuItem value="">-- Full Month --</MenuItem>
//                 {[...Array(31)].map((_, i) => {
//                   const d = pad(i + 1);
//                   return <MenuItem key={d} value={d}>{d}</MenuItem>
//                 })}
//               </Select>
//             </FormControl>

//             <Button 
//               variant="contained" 
//               onClick={displayData} 
//               disabled={loading}
//               sx={{ height: 40, px: 4, fontWeight: 'bold' }}
//             >
//               {loading ? <CircularProgress size={24} color="inherit" /> : "PRESENT DATA"}
//             </Button>

//             <Button 
//               variant="text" 
//               onClick={() => { setDay(""); setMonth(""); setTableData([]); }}
//               sx={{ height: 40, color: 'gray', textTransform: 'none' }}
//             >
//               Clear
//             </Button>
//           </Stack>
//         </Paper>

//         <Card elevation={8}>
//           <CardContent>
//             {loading ? (
//               <Box sx={{ display: "flex", justifyContent: "center", p: 5 }}>
//                 <CircularProgress />
//               </Box>
//             ) : tableData.length > 0 ? (
//               <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
//                 <Table stickyHeader>
//                   <TableHead>
//                     <TableRow>
//                       {Object.keys(tableData[0])
//                         .filter(key => !hiddenKeys.includes(key))
//                         .map((key) => (
//                           <TableCell key={key} sx={{ fontWeight: 'bold', bgcolor: 'background.default', whiteSpace: 'nowrap' }}>
//                             {getHeaderLabel(key)}
//                           </TableCell>
//                         ))}
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {tableData.map((row, index) => (
//                       <TableRow key={index} hover>
//                         {Object.entries(row)
//                           .filter(([key]) => !hiddenKeys.includes(key))
//                           .map(([key, val], i) => {
//                             // ✅ Safety: Ensure value is a string/number, not an object
//                             const displayValue = (val === null || val === undefined) ? "-" : String(val);

//                             if (key === "closed_by_admin") {
//                                 const rawValue = displayValue.toUpperCase();
//                                 if (rawValue.includes("ADMIN") || rawValue.includes("RECEPTION")) {
//                                   return <TableCell key={i}>{displayValue}</TableCell>;
//                                 } else {
//                                   return (
//                                     <TableCell key={i} align="center" sx={{ color: 'red', fontWeight: 'bold', fontSize: '1.2rem' }}>
//                                       X
//                                     </TableCell>
//                                   );
//                                 }
//                             }
//                             return <TableCell key={i}>{displayValue}</TableCell>;
//                           })}
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             ) : (
//               <Typography align="center" sx={{ py: 4 }}>No data found.</Typography>
//             )}
//           </CardContent>
//         </Card>
//       </Box>
//     </LocalizationProvider>
//   );
// }

// export default SendEmailSMS;
/////////////////////////////////////////////////////////////

// import React, { useState } from "react";
// import {
//   Box, Button, CardContent, Table, TableCell, TableContainer,
//   TableHead, TableRow, Card, Paper, TableBody, Typography,
//   CircularProgress, Stack, FormControl, InputLabel, Select, MenuItem, TextField
// } from "@mui/material";
// import { LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import axiosClient from "../axiosClient";
// import dayjs from "dayjs";
// import { useTranslation } from "react-i18next";

// const pad = (n) => String(n).padStart(2, '0');

// function SendEmailSMS() {
//   const { t } = useTranslation();

//   const [loading, setLoading] = useState(false);
//   const [tableData, setTableData] = useState([]);
//   const [day, setDay] = useState("");
//   const [month, setMonth] = useState("");
//   const [year, setYear] = useState(dayjs().year());

//   const hiddenKeys = ["id", "tech_color"];

//   const getHeaderLabel = (key) => {
//     const labels = {
//       room_number: "Room Number",
//       title: "Title",
//       status: "Status",
//       reported: "Reported",
//       staff_name: "Staff Name",
//       finish_time: "Finish Time",
//       closed_by_admin: "Close by",
//     };
//     return labels[key] || key;
//   };

//   const displayData = async () => {
//     setLoading(true);
//     let start, end;

//     if (day && month) {
//       const dateStr = `${year}-${pad(month)}-${pad(day)}`;
//       start = dateStr;
//       end = dateStr;
//     } else if (month) {
//       start = `${year}-${pad(month)}-01`;
//       end = dayjs(start).endOf('month').format("YYYY-MM-DD");
//     } else {
//       start = `${year}-01-01`;
//       end = `${year}-12-31`;
//     }

//     try {
//       const response = await axiosClient.get("issue-list-data/", {
//         params: { start, end }
//       });
//       setTableData(Array.isArray(response.data) ? response.data : []);
//     } catch (err) {
//       console.error("Fetch failed", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ✅ Frontend filter to ensure only data within selected period is shown
//   const filteredData = tableData.filter((row) => {
//     if (!month) return true;

//     const reported = row.reported;
//     if (!reported) return true;

//     const reportedStr = String(reported); // e.g. "03-04-2026 01:40"

//     // Extract day, month, year from "DD-MM-YYYY HH:MM" format
//     const rowDay = reportedStr.slice(0, 2);
//     const rowMonth = reportedStr.slice(3, 5);
//     const rowYear = reportedStr.slice(6, 10);

//     const monthMatches = rowMonth === pad(month);
//     const yearMatches = rowYear === String(year);

//     if (day) {
//       return monthMatches && yearMatches && rowDay === pad(day);
//     }

//     return monthMatches && yearMatches;
//   });

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <Box sx={{ p: 3 }}>
//         <Typography variant="h5" align="center" gutterBottom sx={{ mb: 4, fontWeight: 'bold' }}>
//           ISSUES REPORT
//         </Typography>

//         <Paper elevation={4} sx={{ p: 3, mb: 4 }}>
//           <Stack direction="row" spacing={6} alignItems="center" justifyContent="center">

//             <TextField
//               label="Year"
//               type="number"
//               size="small"
//               sx={{ width: 110 }}
//               value={year}
//               onChange={(e) => {
//                 setYear(e.target.value);
//                 setMonth("");
//                 setDay("");
//               }}
//             />

//             <FormControl size="small" sx={{ minWidth: 130 }}>
//               <InputLabel>Month</InputLabel>
//               <Select
//                 value={month}
//                 label="Month"
//                 onChange={(e) => {
//                   setMonth(e.target.value);
//                   setDay("");
//                 }}
//               >
//                 <MenuItem value="">-- Full Year --</MenuItem>
//                 <MenuItem value="01">January</MenuItem>
//                 <MenuItem value="02">February</MenuItem>
//                 <MenuItem value="03">March</MenuItem>
//                 <MenuItem value="04">April</MenuItem>
//                 <MenuItem value="05">May</MenuItem>
//                 <MenuItem value="06">June</MenuItem>
//                 <MenuItem value="07">July</MenuItem>
//                 <MenuItem value="08">August</MenuItem>
//                 <MenuItem value="09">September</MenuItem>
//                 <MenuItem value="10">October</MenuItem>
//                 <MenuItem value="11">November</MenuItem>
//                 <MenuItem value="12">December</MenuItem>
//               </Select>
//             </FormControl>

//             <FormControl size="small" sx={{ minWidth: 110 }} disabled={!month}>
//               <InputLabel>Day</InputLabel>
//               <Select
//                 value={day}
//                 label="Day"
//                 onChange={(e) => setDay(e.target.value)}
//               >
//                 <MenuItem value="">-- Full Month --</MenuItem>
//                 {[...Array(31)].map((_, i) => {
//                   const d = pad(i + 1);
//                   return <MenuItem key={d} value={d}>{d}</MenuItem>;
//                 })}
//               </Select>
//             </FormControl>

//             <Button
//               variant="contained"
//               onClick={displayData}
//               disabled={loading}
//               sx={{ height: 40, px: 4, fontWeight: 'bold' }}
//             >
//               {loading ? <CircularProgress size={24} color="inherit" /> : "PRESENT DATA"}
//             </Button>

//             <Button
//               variant="text"
//               onClick={() => { setDay(""); setMonth(""); setTableData([]); }}
//               sx={{ height: 40, color: 'gray', textTransform: 'none' }}
//             >
//               Clear
//             </Button>
//           </Stack>
//         </Paper>

//         <Card elevation={8}>
//           <CardContent>
//             {loading ? (
//               <Box sx={{ display: "flex", justifyContent: "center", p: 5 }}>
//                 <CircularProgress />
//               </Box>
//             ) : filteredData.length > 0 ? (
//               <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
//                 <Table stickyHeader>
//                   <TableHead>
//                     <TableRow>
//                       {Object.keys(filteredData[0])
//                         .filter(key => !hiddenKeys.includes(key))
//                         .map((key) => (
//                           <TableCell key={key} sx={{ fontWeight: 'bold', bgcolor: 'background.default', whiteSpace: 'nowrap' }}>
//                             {getHeaderLabel(key)}
//                           </TableCell>
//                         ))}
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {filteredData.map((row, index) => (
//                       <TableRow key={index} hover>
//                         {Object.entries(row)
//                           .filter(([key]) => !hiddenKeys.includes(key))
//                           .map(([key, val], i) => {
//                             const displayValue = (val === null || val === undefined) ? "-" : String(val);

//                             if (key === "closed_by_admin") {
//                               const rawValue = displayValue.toUpperCase();
//                               if (rawValue.includes("ADMIN") || rawValue.includes("RECEPTION")) {
//                                 return <TableCell key={i}>{displayValue}</TableCell>;
//                               } else {
//                                 return (
//                                   <TableCell key={i} align="center" sx={{ color: 'red', fontWeight: 'bold', fontSize: '1.2rem' }}>
//                                     X
//                                   </TableCell>
//                                 );
//                               }
//                             }
//                             return <TableCell key={i}>{displayValue}</TableCell>;
//                           })}
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             ) : (
//               <Typography align="center" sx={{ py: 4 }}>No data found.</Typography>
//             )}
//           </CardContent>
//         </Card>
//       </Box>
//     </LocalizationProvider>
//   );
// }

// export default SendEmailSMS;



///////////////////////////////

// import React, { useState } from "react";
// import {
//   Box, Button, CardContent, Table, TableCell, TableContainer,
//   TableHead, TableRow, Card, Paper, TableBody, Typography, 
//   CircularProgress, Stack, FormControl, InputLabel, Select, MenuItem, TextField
// } from "@mui/material";
// import { LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import axiosClient from "../axiosClient";
// import dayjs from "dayjs";
// import { useTranslation } from "react-i18next";
// import * as XLSX from 'xlsx'; // ✅ Import XLSX

// const pad = (n) => String(n).padStart(2, '0');

// function SendEmailSMS() {
//   const { t } = useTranslation();
//   const [loading, setLoading] = useState(false);
//   const [tableData, setTableData] = useState([]);
//   const [day, setDay] = useState("");
//   const [month, setMonth] = useState("");
//   const [year, setYear] = useState(dayjs().year());

//   const hiddenKeys = ["id", "tech_color"];

//   // ✅ New Function to handle Excel Download
//   const downloadExcel = () => {
//     if (tableData.length === 0) {
//       alert("No data available to download");
//       return;
//     }

//     // Filter out hidden keys from the exported data
//     const exportData = tableData.map(row => {
//       const newRow = {};
//       Object.keys(row).forEach(key => {
//         if (!hiddenKeys.includes(key)) {
//           newRow[key] = row[key];
//         }
//       });
//       return newRow;
//     });

//     const worksheet = XLSX.utils.json_to_sheet(exportData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Issues Report");
    
//     // Generate filename based on selection
//     const fileName = `Issues_Report_${year}${month ? '_' + month : ''}${day ? '_' + day : ''}.xlsx`;
    
//     XLSX.writeFile(workbook, fileName);
//   };

//   const getHeaderLabel = (key) => {
//     const labels = {
//       room_number: "Room Number",
//       title: "Title",
//       status: "Status",
//       reported: "Reported",
//       staff_name: "Staff Name",
//       finish_time: "Finish Time",
//       closed_by_admin: "Close by",
//     };
//     return labels[key] || key;
//   };

//   const displayData = async () => {
//     setLoading(true);
//     let start, end;
//     if (day && month) {
//       const dateStr = `${year}-${pad(month)}-${pad(day)}`;
//       start = dateStr; end = dateStr;
//     } else if (month) {
//       start = `${year}-${pad(month)}-01`;
//       end = dayjs(start).endOf('month').format("YYYY-MM-DD");
//     } else {
//       start = `${year}-01-01`; end = `${year}-12-31`;
//     }

//     try {
//       const response = await axiosClient.get("issue-list-data/", { params: { start, end } });
//       setTableData(Array.isArray(response.data) ? response.data : []);
//     } catch (err) {
//       console.error("Fetch failed", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <Box sx={{ p: 3 }}>
//         <Typography variant="h5" align="center" gutterBottom sx={{ mb: 4, fontWeight: 'bold' }}>
//           ISSUES REPORT
//         </Typography>

//         <Paper elevation={4} sx={{ p: 3, mb: 4 }}>
//           <Stack direction="row" spacing={4} alignItems="center" justifyContent="center">
//             <TextField
//               label="Year" type="number" size="small" sx={{ width: 110 }}
//               value={year} onChange={(e) => { setYear(e.target.value); setMonth(""); setDay(""); }}
//             />

//             <FormControl size="small" sx={{ minWidth: 130 }}>
//               <InputLabel>Month</InputLabel>
//               <Select value={month} label="Month" onChange={(e) => { setMonth(e.target.value); setDay(""); }}>
//                 <MenuItem value="">-- Full Year --</MenuItem>
//                 <MenuItem value="01">January</MenuItem>
//                 <MenuItem value="02">February</MenuItem>
//                 <MenuItem value="03">March</MenuItem>
//                 <MenuItem value="04">April</MenuItem>
//                 <MenuItem value="05">May</MenuItem>
//                 <MenuItem value="06">June</MenuItem>
//                 <MenuItem value="07">July</MenuItem>
//                 <MenuItem value="08">August</MenuItem>
//                 <MenuItem value="09">September</MenuItem>
//                 <MenuItem value="10">October</MenuItem>
//                 <MenuItem value="11">November</MenuItem>
//                 <MenuItem value="12">December</MenuItem>
//               </Select>
//             </FormControl>

//             <FormControl size="small" sx={{ minWidth: 110 }} disabled={!month}>
//               <InputLabel>Day</InputLabel>
//               <Select value={day} label="Day" onChange={(e) => setDay(e.target.value)}>
//                 <MenuItem value="">-- Full Month --</MenuItem>
//                 {[...Array(31)].map((_, i) => {
//                   const d = pad(i + 1);
//                   return <MenuItem key={d} value={d}>{d}</MenuItem>
//                 })}
//               </Select>
//             </FormControl>

//             <Button variant="contained" onClick={displayData} disabled={loading} sx={{ height: 40, fontWeight: 'bold' }}>
//               {loading ? <CircularProgress size={24} color="inherit" /> : "PRESENT DATA"}
//             </Button>

//             {/* ✅ EXCEL BUTTON */}
//             <Button 
//               variant="contained" 
//               color="success" 
//               onClick={downloadExcel} 
//               disabled={loading || tableData.length === 0}
//               sx={{ height: 40, fontWeight: 'bold' }}
//             >
//               DOWNLOAD EXCEL
//             </Button>

//             <Button variant="text" onClick={() => { setDay(""); setMonth(""); setTableData([]); }} sx={{ height: 40, color: 'gray' }}>
//               Clear
//             </Button>
//           </Stack>
//         </Paper>

//         <Card elevation={8}>
//           <CardContent>
//             {loading ? (
//               <Box sx={{ display: "flex", justifyContent: "center", p: 5 }}><CircularProgress /></Box>
//             ) : tableData.length > 0 ? (
//               <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
//                 <Table stickyHeader>
//                   <TableHead>
//                     <TableRow>
//                       {Object.keys(tableData[0]).filter(key => !hiddenKeys.includes(key)).map((key) => (
//                         <TableCell key={key} sx={{ fontWeight: 'bold', bgcolor: 'background.default' }}>
//                           {getHeaderLabel(key)}
//                         </TableCell>
//                       ))}
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {tableData.map((row, index) => (
//                       <TableRow key={index} hover>
//                         {Object.entries(row).filter(([key]) => !hiddenKeys.includes(key)).map(([key, val], i) => {
//                           const displayValue = (val === null || val === undefined) ? "-" : String(val);
//                           return <TableCell key={i}>{displayValue}</TableCell>;
//                         })}
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             ) : (
//               <Typography align="center" sx={{ py: 4 }}>No data found.</Typography>
//             )}
//           </CardContent>
//         </Card>
//       </Box>
//     </LocalizationProvider>
//   );
// }

// export default SendEmailSMS;

// import React, { useState } from "react";
// import {
//   Box, Button, CardContent, Table, TableCell, TableContainer,
//   TableHead, TableRow, Card, Paper, TableBody, Typography, 
//   CircularProgress, Stack, FormControl, InputLabel, Select, MenuItem, TextField
// } from "@mui/material";
// import { LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import axiosClient from "../axiosClient";
// import dayjs from "dayjs";
// import { useTranslation } from "react-i18next";
// import * as XLSX from 'xlsx'; 

// // Helper defined outside the component
// const pad = (n) => String(n).padStart(2, '0');

// function SendEmailSMS() {
//   const { t } = useTranslation();
  
//   const [loading, setLoading] = useState(false);
//   const [tableData, setTableData] = useState([]);
//   const [day, setDay] = useState("");
//   const [month, setMonth] = useState("");
//   const [year, setYear] = useState(dayjs().year());

//   // ✅ Added "scheduled_end" to hiddenKeys to remove it from table and Excel
//   const hiddenKeys = ["id", "tech_color", "scheduled_end"];

//   const getHeaderLabel = (key) => {
//     const labels = {
//       room_number: "Room Number",
//       title: "Title",
//       status: "Status",
//       reported: "Reported",
//       staff_name: "Staff Name",
//       finish_time: "Finish Time",
//       appt_start: "Issue Start Time", // ✅ Updated Label
//       closed_by_admin: "Close by",
//     };
//     return labels[key] || key;
//   };

//   // ✅ Excel Download Logic
//   const downloadExcel = () => {
//     if (tableData.length === 0) return;

//     const exportData = tableData.map(row => {
//       const newRow = {};
//       Object.keys(row).forEach(key => {
//         if (!hiddenKeys.includes(key)) {
//           // Use the pretty labels for Excel headers
//           const label = getHeaderLabel(key);
//           newRow[label] = row[key] || "-";
//         }
//       });
//       return newRow;
//     });

//     const worksheet = XLSX.utils.json_to_sheet(exportData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Issues Report");
//     XLSX.writeFile(workbook, `Issues_Report_${year}_${month || 'Year'}.xlsx`);
//   };

//   const displayData = async () => {
//     setLoading(true);
//     let start, end;

//     if (day && month) {
//       const dateStr = `${year}-${pad(month)}-${pad(day)}`;
//       start = dateStr;
//       end = dateStr;
//     } else if (month) {
//       start = `${year}-${pad(month)}-01`;
//       end = dayjs(start).endOf('month').format("YYYY-MM-DD");
//     } else {
//       start = `${year}-01-01`;
//       end = `${year}-12-31`;
//     }

//     try {
//       const response = await axiosClient.get("issue-list-data/", { 
//         params: { start, end } 
//       });
//       setTableData(Array.isArray(response.data) ? response.data : []);
//     } catch (err) {
//       console.error("Fetch failed", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <Box sx={{ p: 3 }}>
//         <Typography variant="h5" align="center" gutterBottom sx={{ mb: 4, fontWeight: 'bold' }}>
//           ISSUES REPORT
//         </Typography>

//         <Paper elevation={4} sx={{ p: 3, mb: 4 }}>
//           <Stack direction="row" spacing={6} alignItems="center" justifyContent="center">
            
//             <TextField
//               label="Year" type="number" size="small" sx={{ width: 110 }}
//               value={year}
//               onChange={(e) => { setYear(e.target.value); setMonth(""); setDay(""); }}
//             />

//             <FormControl size="small" sx={{ minWidth: 130 }}>
//               <InputLabel>Month</InputLabel>
//               <Select value={month} label="Month" onChange={(e) => { setMonth(e.target.value); setDay(""); }}>
//                 <MenuItem value="">-- Full Year --</MenuItem>
//                 {["01","02","03","04","05","06","07","08","09","10","11","12"].map((m, i) => (
//                   <MenuItem key={m} value={m}>{dayjs().month(i).format('MMMM')}</MenuItem>
//                 ))}
//               </Select>
//             </FormControl>

//             <FormControl size="small" sx={{ minWidth: 110 }} disabled={!month}>
//               <InputLabel>Day</InputLabel>
//               <Select value={day} label="Day" onChange={(e) => setDay(e.target.value)}>
//                 <MenuItem value="">-- Full Month --</MenuItem>
//                 {[...Array(31)].map((_, i) => {
//                   const d = pad(i + 1);
//                   return <MenuItem key={d} value={d}>{d}</MenuItem>
//                 })}
//               </Select>
//             </FormControl>

//             <Button variant="contained" onClick={displayData} disabled={loading} sx={{ height: 40, px: 4, fontWeight: 'bold' }}>
//               {loading ? <CircularProgress size={24} color="inherit" /> : "PRESENT DATA"}
//             </Button>

//             <Button variant="contained" color="success" onClick={downloadExcel} disabled={tableData.length === 0} sx={{ height: 40, px: 4, fontWeight: 'bold' }}>
//               DOWNLOAD EXCEL
//             </Button>

//             <Button variant="text" onClick={() => { setDay(""); setMonth(""); setTableData([]); }} sx={{ height: 40, color: 'gray', textTransform: 'none' }}>
//               Clear
//             </Button>
//           </Stack>
//         </Paper>

//         <Card elevation={8}>
//           <CardContent>
//             {loading ? (
//               <Box sx={{ display: "flex", justifyContent: "center", p: 5 }}><CircularProgress /></Box>
//             ) : tableData.length > 0 ? (
//               <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
//                 <Table stickyHeader>
//                   <TableHead>
//                     <TableRow>
//                       {Object.keys(tableData[0])
//                         .filter(key => !hiddenKeys.includes(key))
//                         .map((key) => (
//                           <TableCell key={key} sx={{ fontWeight: 'bold', bgcolor: 'background.default' }}>
//                             {getHeaderLabel(key)}
//                           </TableCell>
//                         ))}
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {tableData.map((row, index) => (
//                       <TableRow key={index} hover>
//                         {Object.entries(row)
//                           .filter(([key]) => !hiddenKeys.includes(key))
//                           .map(([key, val], i) => {
//                             const displayValue = (val === null || val === undefined) ? "-" : String(val);
                            
//                             if (key === "closed_by_admin") {
//                                 const rawValue = displayValue.toUpperCase();
//                                 if (rawValue.includes("ADMIN") || rawValue.includes("RECEPTION")) {
//                                   return <TableCell key={i}>{displayValue}</TableCell>;
//                                 } else {
//                                   return <TableCell key={i} align="center" sx={{ color: 'red', fontWeight: 'bold' }}>X</TableCell>;
//                                 }
//                             }
//                             return <TableCell key={i}>{displayValue}</TableCell>;
//                           })}
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             ) : (
//               <Typography align="center" sx={{ py: 4 }}>No data found.</Typography>
//             )}
//           </CardContent>
//         </Card>
//       </Box>
//     </LocalizationProvider>
//   );
// }

// export default SendEmailSMS;

////////////////////////////////////////////////////////////////////////////////////////////////////////

// import React, { useState } from "react";
// import {
//   Box, Button, CardContent, Table, TableCell, TableContainer,
//   TableHead, TableRow, Card, Paper, TableBody, Typography, 
//   CircularProgress, Stack, FormControl, InputLabel, Select, MenuItem, TextField
// } from "@mui/material";
// import { LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import axiosClient from "../axiosClient";
// import dayjs from "dayjs";
// import customParseFormat from "dayjs/plugin/customParseFormat"; 
// import { useTranslation } from "react-i18next";
// import * as XLSX from 'xlsx';

// dayjs.extend(customParseFormat);

// const pad = (n) => String(n).padStart(2, '0');

// function SendEmailSMS() {
//   const { t } = useTranslation();
//   const [loading, setLoading] = useState(false);
//   const [tableData, setTableData] = useState([]);
//   const [day, setDay] = useState("");
//   const [month, setMonth] = useState("");
//   const [year, setYear] = useState(dayjs().year());

//   const hiddenKeys = ["id", "tech_color", "scheduled_end"];

//   const getHeaderLabel = (key) => {
//     const labels = {
//       room_number: "Room Number",
//       title: "Title",
//       status: "Status",
//       reported: "Reported At",
//       staff_name: "Staff Name",
//       finish_time: "Finish Time",
//       appt_start: "Issue Start", 
//       closed_by_admin: "Close by",
//     };
//     return labels[key] || key;
//   };

//   // ✅ Updated to show BOTH Date and Time: DD-MM-YYYY HH:mm
//   const formatDateTimeSafe = (val) => {
//     if (!val || val === "-" || val === "null" || val === "None") return "-";
    
//     // Parse various formats coming from the database
//     const d = dayjs(val, ["YYYY-MM-DDTHH:mm:ss", "YYYY-MM-DD HH:mm:ss", "DD-MM-YYYY HH:mm"]);
    
//     if (d.isValid()) {
//       return d.format("DD-MM-YYYY HH:mm");
//     }

//     return val; 
//   };

//   const downloadExcel = () => {
//     if (tableData.length === 0) return;

//     const exportData = tableData.map(row => {
//       const newRow = {};
//       Object.keys(row).forEach(key => {
//         if (!hiddenKeys.includes(key)) {
//           const label = getHeaderLabel(key);
//           let val = row[key];

//           const timeCols = ["finish_time", "appt_start", "reported"];
//           if (timeCols.includes(key)) {
//             val = formatDateTimeSafe(val);
//           }
//           newRow[label] = val || "-";
//         }
//       });
//       return newRow;
//     });

//     const worksheet = XLSX.utils.json_to_sheet(exportData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Issues Report");
//     XLSX.writeFile(workbook, `Issues_Report_${year}_${month || 'Year'}.xlsx`);
//   };

//   const displayData = async () => {
//     setLoading(true);
//     let start, end;
//     if (day && month) {
//       const dateStr = `${year}-${pad(month)}-${pad(day)}`;
//       start = dateStr; end = dateStr;
//     } else if (month) {
//       start = `${year}-${pad(month)}-01`;
//       end = dayjs(start).endOf('month').format("YYYY-MM-DD");
//     } else {
//       start = `${year}-01-01`; end = `${year}-12-31`;
//     }

//     try {
//       const response = await axiosClient.get("issue-list-data/", { params: { start, end } });
//       setTableData(Array.isArray(response.data) ? response.data : []);
//     } catch (err) {
//       console.error("Fetch failed", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <Box sx={{ p: 3 }}>
//         <Typography variant="h5" align="center" gutterBottom sx={{ mb: 4, fontWeight: 'bold' }}>
//           ISSUES REPORT
//         </Typography>

//         <Paper elevation={4} sx={{ p: 3, mb: 4 }}>
//           <Stack direction="row" spacing={6} alignItems="center" justifyContent="center">
//             <TextField
//               label="Year" type="number" size="small" sx={{ width: 110 }}
//               value={year} onChange={(e) => { setYear(e.target.value); setMonth(""); setDay(""); }}
//             />

//             <FormControl size="small" sx={{ minWidth: 130 }}>
//               <InputLabel>Month</InputLabel>
//               <Select value={month} label="Month" onChange={(e) => { setMonth(e.target.value); setDay(""); }}>
//                 <MenuItem value="">-- Full Year --</MenuItem>
//                 {["01","02","03","04","05","06","07","08","09","10","11","12"].map((m, i) => (
//                   <MenuItem key={m} value={m}>{dayjs().month(i).format('MMMM')}</MenuItem>
//                 ))}
//               </Select>
//             </FormControl>

//             <FormControl size="small" sx={{ minWidth: 110 }} disabled={!month}>
//               <InputLabel>Day</InputLabel>
//               <Select value={day} label="Day" onChange={(e) => setDay(e.target.value)}>
//                 <MenuItem value="">-- Full Month --</MenuItem>
//                 {[...Array(31)].map((_, i) => (
//                   <MenuItem key={pad(i + 1)} value={pad(i + 1)}>{pad(i + 1)}</MenuItem>
//                 ))}
//               </Select>
//             </FormControl>

//             <Button variant="contained" onClick={displayData} disabled={loading} sx={{ height: 40, px: 4, fontWeight: 'bold' }}>
//               {loading ? <CircularProgress size={24} color="inherit" /> : "PRESENT DATA"}
//             </Button>

//             <Button variant="contained" color="success" onClick={downloadExcel} disabled={tableData.length === 0} sx={{ height: 40, px: 4, fontWeight: 'bold' }}>
//               DOWNLOAD EXCEL
//             </Button>

//             <Button variant="text" onClick={() => { setDay(""); setMonth(""); setTableData([]); }} sx={{ height: 40, color: 'gray', textTransform: 'none' }}>
//               Clear
//             </Button>
//           </Stack>
//         </Paper>

//         <Card elevation={8}>
//           <CardContent>
//             {loading ? (
//               <Box sx={{ display: "flex", justifyContent: "center", p: 5 }}><CircularProgress /></Box>
//             ) : tableData.length > 0 ? (
//               <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
//                 <Table stickyHeader>
//                   <TableHead>
//                     <TableRow>
//                       {Object.keys(tableData[0]).filter(key => !hiddenKeys.includes(key)).map((key) => (
//                         <TableCell key={key} sx={{ fontWeight: 'bold', bgcolor: 'background.default' }}>
//                           {getHeaderLabel(key)}
//                         </TableCell>
//                       ))}
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {tableData.map((row, index) => (
//                       <TableRow key={index} hover>
//                         {Object.entries(row).filter(([key]) => !hiddenKeys.includes(key)).map(([key, val], i) => {
//                           let displayValue = val;

//                           // Apply the Date-Time format
//                           const timeCols = ["finish_time", "appt_start", "reported"];
//                           if (timeCols.includes(key)) {
//                             displayValue = formatDateTimeSafe(val);
//                           }

//                           if (key === "closed_by_admin") {
//                             const rawValue = String(displayValue || "").toUpperCase();
//                             if (rawValue.includes("ADMIN") || rawValue.includes("RECEPTION")) {
//                               return <TableCell key={i}>{displayValue}</TableCell>;
//                             } else {
//                               return <TableCell key={i} align="center" sx={{ color: 'red', fontWeight: 'bold' }}>X</TableCell>;
//                             }
//                           }
//                           return <TableCell key={i}>{displayValue || "-"}</TableCell>;
//                         })}
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             ) : (
//               <Typography align="center" sx={{ py: 4 }}>No data found.</Typography>
//             )}
//           </CardContent>
//         </Card>
//       </Box>
//     </LocalizationProvider>
//   );
// }

// export default SendEmailSMS;


// ////////////////////////////////////////////////////////////////////////////////////////////////////////

// import React, { useState } from "react";
// // 1. Added IconButton, Tooltip, and DeleteIcon to imports
// import {
//   Box, Button, CardContent, Table, TableCell, TableContainer,
//   TableHead, TableRow, Card, Paper, TableBody, Typography, 
//   CircularProgress, Stack, FormControl, InputLabel, Select, MenuItem, TextField,
//   IconButton, Tooltip 
// } from "@mui/material";
// import DeleteIcon from "@mui/icons-material/Delete"; 
// import { LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import axiosClient from "../axiosClient";
// import dayjs from "dayjs";
// import customParseFormat from "dayjs/plugin/customParseFormat"; 
// import { useTranslation } from "react-i18next";
// import { useStateContext } from "../context/ContextProvider"; // 2. Import context for user role
// import * as XLSX from 'xlsx';

// dayjs.extend(customParseFormat);

// const pad = (n) => String(n).padStart(2, '0');

// function SendEmailSMS() {
//   const { t } = useTranslation();
//   const { user } = useStateContext(); // 3. Get current user
//   const [loading, setLoading] = useState(false);
//   const [tableData, setTableData] = useState([]);
//   const [day, setDay] = useState("");
//   const [month, setMonth] = useState("");
//   const [year, setYear] = useState(dayjs().year());

//   const hiddenKeys = ["id", "tech_color", "scheduled_end"];

//   // 4. Delete Logic
//   const handleDelete = async (id) => {
//     if (window.confirm("Are you sure you want to delete this issue?")) {
//       try {
//         await axiosClient.delete(`issues/${id}/`);
//         displayData(); // Refresh the table
//       } catch (err) {
//         console.error("Delete failed", err);
//         alert("Delete failed. Check permissions.");
//       }
//     }
//   };

//   const getHeaderLabel = (key) => {
//     const labels = {
//       room_number: "Room Number",
//       title: "Title",
//       status: "Status",
//       reported: "Reported At",
//       staff_name: "Staff Name",
//       finish_time: "Finish Time",
//       appt_start: "Issue Start", 
//       closed_by_admin: "Close by",
//     };
//     return labels[key] || key;
//   };

//   const formatDateTimeSafe = (val) => {
//     if (!val || val === "-" || val === "null" || val === "None") return "-";
//     const d = dayjs(val, ["YYYY-MM-DDTHH:mm:ss", "YYYY-MM-DD HH:mm:ss", "DD-MM-YYYY HH:mm"]);
//     if (d.isValid()) return d.format("DD-MM-YYYY HH:mm");
//     return val; 
//   };

//   const downloadExcel = () => {
//     if (tableData.length === 0) return;
//     const exportData = tableData.map(row => {
//       const newRow = {};
//       Object.keys(row).forEach(key => {
//         if (!hiddenKeys.includes(key)) {
//           const label = getHeaderLabel(key);
//           let val = row[key];
//           const timeCols = ["finish_time", "appt_start", "reported"];
//           if (timeCols.includes(key)) val = formatDateTimeSafe(val);
//           newRow[label] = val || "-";
//         }
//       });
//       return newRow;
//     });
//     const worksheet = XLSX.utils.json_to_sheet(exportData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Issues Report");
//     XLSX.writeFile(workbook, `Issues_Report_${year}_${month || 'Year'}.xlsx`);
//   };

//   const displayData = async () => {
//     setLoading(true);
//     let start, end;
//     if (day && month) {
//       const dateStr = `${year}-${pad(month)}-${pad(day)}`;
//       start = dateStr; end = dateStr;
//     } else if (month) {
//       start = `${year}-${pad(month)}-01`;
//       end = dayjs(start).endOf('month').format("YYYY-MM-DD");
//     } else {
//       start = `${year}-01-01`; end = `${year}-12-31`;
//     }

//     try {
//       const response = await axiosClient.get("issue-list-data/", { params: { start, end } });
//       setTableData(Array.isArray(response.data) ? response.data : []);
//     } catch (err) {
//       console.error("Fetch failed", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <Box sx={{ p: 3 }}>
//         <Typography variant="h5" align="center" gutterBottom sx={{ mb: 4, fontWeight: 'bold' }}>
//           ISSUES REPORT
//         </Typography>

//         {/* ... (Keep Filter Stack the same) ... */}
//         <Paper elevation={4} sx={{ p: 3, mb: 4 }}>
//           <Stack direction="row" spacing={6} alignItems="center" justifyContent="center">
//             <TextField
//               label="Year" type="number" size="small" sx={{ width: 110 }}
//               value={year} onChange={(e) => { setYear(e.target.value); setMonth(""); setDay(""); }}
//             />
//             {/* ... Other inputs ... */}
//             <Button variant="contained" onClick={displayData} disabled={loading}>PRESENT DATA</Button>
//             <Button variant="contained" color="success" onClick={downloadExcel} disabled={tableData.length === 0}>DOWNLOAD EXCEL</Button>
//           </Stack>
//         </Paper>

//         <Card elevation={8}>
//           <CardContent>
//             {loading ? (
//               <Box sx={{ display: "flex", justifyContent: "center", p: 5 }}><CircularProgress /></Box>
//             ) : tableData.length > 0 ? (
//               <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
//                 <Table stickyHeader>
                  
//                   <TableHead>
//                     <TableRow>
//                       {Object.keys(tableData[0]).filter(key => !hiddenKeys.includes(key)).map((key) => (
//                         <TableCell key={key} sx={{ fontWeight: 'bold', bgcolor: 'background.default' }}>
//                           {getHeaderLabel(key)}
//                         </TableCell>
//                       ))}
                      
//                       {/* ✅ ADD THIS BLOCK HERE */}
//                       {user?.user_role === "ADMIN" && (
//                         <TableCell sx={{ fontWeight: 'bold', bgcolor: 'background.default' }} align="center">
//                           Action
//                         </TableCell>
//                       )}
//                     </TableRow>
//                   </TableHead>    

// ///////////////////////////////////////////////////////
//                   <TableBody>
//                     {tableData.map((row, index) => (
//                       <TableRow key={index} hover>
//                         {Object.entries(row).filter(([key]) => !hiddenKeys.includes(key)).map(([key, val], i) => {
//                           let displayValue = val;
//                           const timeCols = ["finish_time", "appt_start", "reported"];
//                           if (timeCols.includes(key)) displayValue = formatDateTimeSafe(val);
                          
//                           if (key === "closed_by_admin") {
//                              const rawValue = String(displayValue || "").toUpperCase();
//                              return (rawValue.includes("ADMIN") || rawValue.includes("RECEPTION")) 
//                                 ? <TableCell key={i}>{displayValue}</TableCell>
//                                 : <TableCell key={i} align="center" sx={{ color: 'red', fontWeight: 'bold' }}>X</TableCell>;
//                           }
//                           return <TableCell key={i}>{displayValue || "-"}</TableCell>;
//                         })}
                        
//                         {/* 6. Conditional Delete Button for Admin */}
//                         {user?.user_role === "ADMIN" && (
//                           <TableCell align="center">
//                             <Tooltip title="Delete Issue">
//                               <IconButton color="error" onClick={() => handleDelete(row.id)}>
//                                 <DeleteIcon fontSize="small" />
//                               </IconButton>
//                             </Tooltip>
//                           </TableCell>
//                         )}
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                   /////////////////////////////////////////
//                   <TableRow key={index} hover>
//                       {/* This is your existing loop that shows Room, Title, etc. */}
//                       {Object.entries(row).filter(([key]) => !hiddenKeys.includes(key)).map(([key, val], i) => {
//                         // ... your existing display logic ...
//                         return <TableCell key={i}>{displayValue || "-"}</TableCell>;
//                       })}

//                       {/* ✅ ADD THIS BLOCK RIGHT HERE (Before the closing </TableRow>) */}
//                       {user?.user_role === "ADMIN" && (
//                         <TableCell align="center">
//                           <Tooltip title="Delete Issue">
//                             <IconButton color="error" onClick={() => handleDelete(row.id)}>
//                               <DeleteIcon fontSize="small" />
//                             </IconButton>
//                           </Tooltip>
//                         </TableCell>
//                       )}
//                     </TableRow>
//                   ////////////////////////////////////////
//                 </Table>
//               </TableContainer>
//             ) : (
//               <Typography align="center" sx={{ py: 4 }}>No data found.</Typography>
//             )}
//           </CardContent>
//         </Card>
//       </Box>
//     </LocalizationProvider>
//   );
// }

// export default SendEmailSMS;






import React, { useState } from "react";
import {
  Box, Button, CardContent, Table, TableCell, TableContainer,
  TableHead, TableRow, Card, Paper, TableBody, Typography, 
  CircularProgress, Stack, FormControl, InputLabel, Select, MenuItem, TextField,
  IconButton, Tooltip 
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete"; 
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import axiosClient from "../axiosClient";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat"; 
import { useTranslation } from "react-i18next";
import { useStateContext } from "../context/ContextProvider"; 
import * as XLSX from 'xlsx';

dayjs.extend(customParseFormat);

const pad = (n) => String(n).padStart(2, '0');

function SendEmailSMS() {
  const { t } = useTranslation();
  const { user } = useStateContext(); 
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [day, setDay] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState(dayjs().year());

  // Determine if user is Admin (case-insensitive check)
  const isAdmin = user?.user_role?.toUpperCase() === "ADMIN";

  const hiddenKeys = ["id", "tech_color", "scheduled_end"];

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this issue?")) {
      try {
        await axiosClient.delete(`issues/${id}/`);
        displayData(); 
      } catch (err) {
        console.error("Delete failed", err);
        alert("Delete failed. Check permissions.");
      }
    }
  };

  const getHeaderLabel = (key) => {
    const labels = {
      room_number: "Room Number",
      title: "Title",
      status: "Status",
      reported: "Reported At",
      staff_name: "Staff Name",
      finish_time: "Finish Time",
      appt_start: "Issue Start", 
      closed_by_admin: "Close by",
    };
    return labels[key] || key;
  };

  const formatDateTimeSafe = (val) => {
    if (!val || val === "-" || val === "null" || val === "None") return "-";
    const d = dayjs(val, ["YYYY-MM-DDTHH:mm:ss", "YYYY-MM-DD HH:mm:ss", "DD-MM-YYYY HH:mm"]);
    if (d.isValid()) return d.format("DD-MM-YYYY HH:mm");
    return val; 
  };

  const downloadExcel = () => {
    if (tableData.length === 0) return;
    const exportData = tableData.map(row => {
      const newRow = {};
      Object.keys(row).forEach(key => {
        if (!hiddenKeys.includes(key)) {
          const label = getHeaderLabel(key);
          let val = row[key];
          const timeCols = ["finish_time", "appt_start", "reported"];
          if (timeCols.includes(key)) val = formatDateTimeSafe(val);
          newRow[label] = val || "-";
        }
      });
      return newRow;
    });
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Issues Report");
    XLSX.writeFile(workbook, `Issues_Report_${year}_${month || 'Year'}.xlsx`);
  };

  const displayData = async () => {
    setLoading(true);
    let start, end;
    if (day && month) {
      const dateStr = `${year}-${pad(month)}-${pad(day)}`;
      start = dateStr; end = dateStr;
    } else if (month) {
      start = `${year}-${pad(month)}-01`;
      end = dayjs(start).endOf('month').format("YYYY-MM-DD");
    } else {
      start = `${year}-01-01`; end = `${year}-12-31`;
    }

    try {
      const response = await axiosClient.get("issue-list-data/", { params: { start, end } });
      setTableData(Array.isArray(response.data) ? response.data : []);
    } catch (err) {
      console.error("Fetch failed", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ p: 3 }}>
        <Typography variant="h5" align="center" gutterBottom sx={{ mb: 4, fontWeight: 'bold' }}>
          ISSUES REPORT
        </Typography>

        <Paper elevation={4} sx={{ p: 3, mb: 4 }}>
          <Stack direction="row" spacing={6} alignItems="center" justifyContent="center">
            <TextField
              label="Year" type="number" size="small" sx={{ width: 110 }}
              value={year} onChange={(e) => { setYear(e.target.value); setMonth(""); setDay(""); }}
            />

            <FormControl size="small" sx={{ minWidth: 130 }}>
              <InputLabel>Month</InputLabel>
              <Select value={month} label="Month" onChange={(e) => { setMonth(e.target.value); setDay(""); }}>
                <MenuItem value="">-- Full Year --</MenuItem>
                {["01","02","03","04","05","06","07","08","09","10","11","12"].map((m, i) => (
                  <MenuItem key={m} value={m}>{dayjs().month(i).format('MMMM')}</MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl size="small" sx={{ minWidth: 110 }} disabled={!month}>
              <InputLabel>Day</InputLabel>
              <Select value={day} label="Day" onChange={(e) => setDay(e.target.value)}>
                <MenuItem value="">-- Full Month --</MenuItem>
                {[...Array(31)].map((_, i) => (
                  <MenuItem key={pad(i + 1)} value={pad(i + 1)}>{pad(i + 1)}</MenuItem>
                ))}
              </Select>
            </FormControl>

            <Button variant="contained" onClick={displayData} disabled={loading} sx={{ height: 40, px: 4, fontWeight: 'bold' }}>
              {loading ? <CircularProgress size={24} color="inherit" /> : "PRESENT DATA"}
            </Button>

            <Button variant="contained" color="success" onClick={downloadExcel} disabled={tableData.length === 0} sx={{ height: 40, px: 4, fontWeight: 'bold' }}>
              DOWNLOAD EXCEL
            </Button>

            <Button variant="text" onClick={() => { setDay(""); setMonth(""); setTableData([]); }} sx={{ height: 40, color: 'gray', textTransform: 'none' }}>
              Clear
            </Button>
          </Stack>
        </Paper>

        <Card elevation={8}>
          <CardContent>
            {loading ? (
              <Box sx={{ display: "flex", justifyContent: "center", p: 5 }}><CircularProgress /></Box>
            ) : tableData.length > 0 ? (
              <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      {Object.keys(tableData[0]).filter(key => !hiddenKeys.includes(key)).map((key) => (
                        <TableCell key={key} sx={{ fontWeight: 'bold', bgcolor: 'background.default' }}>
                          {getHeaderLabel(key)}
                        </TableCell>
                      ))}
                      {isAdmin && (
                        <TableCell align="center" sx={{ fontWeight: 'bold', bgcolor: 'background.default' }}>
                          Action
                        </TableCell>
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tableData.map((row, index) => (
                      <TableRow key={index} hover>
                        {Object.entries(row).filter(([key]) => !hiddenKeys.includes(key)).map(([key, val], i) => {
                          let displayValue = val;
                          const timeCols = ["finish_time", "appt_start", "reported"];
                          if (timeCols.includes(key)) displayValue = formatDateTimeSafe(val);
                          
                          if (key === "closed_by_admin") {
                            const rawValue = String(displayValue || "").toUpperCase();
                            if (rawValue.includes("ADMIN") || rawValue.includes("RECEPTION")) {
                              return <TableCell key={i}>{displayValue}</TableCell>;
                            } else {
                              return <TableCell key={i} align="center" sx={{ color: 'red', fontWeight: 'bold' }}>X</TableCell>;
                            }
                          }
                          return <TableCell key={i}>{displayValue || "-"}</TableCell>;
                        })}

                        {isAdmin && (
                          <TableCell align="center">
                            <Tooltip title="Delete Issue">
                              <IconButton color="error" onClick={() => handleDelete(row.id)}>
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        )}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Typography align="center" sx={{ py: 4 }}>No data found.</Typography>
            )}
          </CardContent>
        </Card>
      </Box>
    </LocalizationProvider>
  );
}

export default SendEmailSMS;